function $22652eaee0e28bba$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}


const $5d9dcac8659633df$export$20d68f04f30763a5 = (0, $22652eaee0e28bba$export$7c73462e0d25e514)(()=>window.ScrollTimeline !== undefined);


class $740d8c3a222837de$export$c1e41718f71efe41 {
    constructor(animations){
        // Bound to accomodate common `return animation.stop` pattern
        this.stop = ()=>this.runAll("stop");
        this.animations = animations.filter(Boolean);
    }
    then(onResolve, onReject) {
        return Promise.all(this.animations).then(onResolve).catch(onReject);
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ getAll(propName) {
        return this.animations[0][propName];
    }
    setAll(propName, newValue) {
        for(let i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
    }
    attachTimeline(timeline, fallback) {
        const subscriptions = this.animations.map((animation)=>{
            if ((0, $5d9dcac8659633df$export$20d68f04f30763a5)() && animation.attachTimeline) return animation.attachTimeline(timeline);
            else return fallback(animation);
        });
        return ()=>{
            subscriptions.forEach((cancel, i)=>{
                cancel && cancel();
                this.animations[i].stop();
            });
        };
    }
    get time() {
        return this.getAll("time");
    }
    set time(time) {
        this.setAll("time", time);
    }
    get speed() {
        return this.getAll("speed");
    }
    set speed(speed) {
        this.setAll("speed", speed);
    }
    get startTime() {
        return this.getAll("startTime");
    }
    get duration() {
        let max = 0;
        for(let i = 0; i < this.animations.length; i++)max = Math.max(max, this.animations[i].duration);
        return max;
    }
    runAll(methodName) {
        this.animations.forEach((controls)=>controls[methodName]());
    }
    flatten() {
        this.runAll("flatten");
    }
    play() {
        this.runAll("play");
    }
    pause() {
        this.runAll("pause");
    }
    cancel() {
        this.runAll("cancel");
    }
    complete() {
        this.runAll("complete");
    }
}


/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $cb0a4d7c7c382e92$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};


const $6895d092cec78af0$export$66d3851e2b1ec912 = (easing, duration, resolution = 10 // as milliseconds
)=>{
    let points = "";
    const numPoints = Math.max(Math.round(duration / resolution), 2);
    for(let i = 0; i < numPoints; i++)points += easing((0, $cb0a4d7c7c382e92$export$504d7abb21fa8c9)(0, numPoints - 1, i)) + ", ";
    return `linear(${points.substring(0, points.length - 2)})`;
};


/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $a20bf34b6c7fb9be$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $a20bf34b6c7fb9be$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;


/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $9b2f55ea2d96c166$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $ba040d3e059872ef$var$velocitySampleDuration = 5; // ms
function $ba040d3e059872ef$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $ba040d3e059872ef$var$velocitySampleDuration, 0);
    return (0, $9b2f55ea2d96c166$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}


const $b971a0c42800d23e$export$8793edee2d425525 = (any)=>any;


let $ee01c60b140b7aca$export$491112666e282270 = (0, $b971a0c42800d23e$export$8793edee2d425525);
let $ee01c60b140b7aca$export$f5708dca728d7177 = (0, $b971a0c42800d23e$export$8793edee2d425525);
var $ee01c60b140b7aca$var$check, $ee01c60b140b7aca$var$message, $ee01c60b140b7aca$var$check1, $ee01c60b140b7aca$var$message1;


const $0c8f57795abc012c$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};



const $0ad6218156594f06$export$86436497e7b05d16 = {
    // Default spring physics
    stiffness: 100,
    damping: 10,
    mass: 1.0,
    velocity: 0.0,
    // Default duration/bounce-based options
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    // Rest thresholds
    restSpeed: {
        granular: 0.01,
        default: 2
    },
    restDelta: {
        granular: 0.005,
        default: 0.5
    },
    // Limits
    minDuration: 0.01,
    maxDuration: 10.0,
    minDamping: 0.05,
    maxDamping: 1
};


const $a3434a995f8a72f8$var$safeMin = 0.001;
function $a3434a995f8a72f8$export$b15f158dc6d6f458({ duration: duration = (0, $0ad6218156594f06$export$86436497e7b05d16).duration, bounce: bounce = (0, $0ad6218156594f06$export$86436497e7b05d16).bounce, velocity: velocity = (0, $0ad6218156594f06$export$86436497e7b05d16).velocity, mass: mass = (0, $0ad6218156594f06$export$86436497e7b05d16).mass }) {
    let envelope;
    let derivative;
    (0, $ee01c60b140b7aca$export$491112666e282270)(duration <= (0, $a20bf34b6c7fb9be$export$fc3e7e8557f8c8c7)((0, $0ad6218156594f06$export$86436497e7b05d16).maxDuration), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $0c8f57795abc012c$export$7d15b64cf5a3a4c4)((0, $0ad6218156594f06$export$86436497e7b05d16).minDamping, (0, $0ad6218156594f06$export$86436497e7b05d16).maxDamping, dampingRatio);
    duration = (0, $0c8f57795abc012c$export$7d15b64cf5a3a4c4)((0, $0ad6218156594f06$export$86436497e7b05d16).minDuration, (0, $0ad6218156594f06$export$86436497e7b05d16).maxDuration, (0, $a20bf34b6c7fb9be$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $a3434a995f8a72f8$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $a3434a995f8a72f8$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $a3434a995f8a72f8$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $a3434a995f8a72f8$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$a3434a995f8a72f8$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $a3434a995f8a72f8$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $a20bf34b6c7fb9be$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: (0, $0ad6218156594f06$export$86436497e7b05d16).stiffness,
        damping: (0, $0ad6218156594f06$export$86436497e7b05d16).damping,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $a3434a995f8a72f8$var$rootIterations = 12;
function $a3434a995f8a72f8$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $a3434a995f8a72f8$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $a3434a995f8a72f8$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $22da538acfb87e5a$export$f4ff70a5b4808fd8 = 20000;
function $22da538acfb87e5a$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $22da538acfb87e5a$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $22da538acfb87e5a$export$f4ff70a5b4808fd8 ? Infinity : duration;
}




const $0071f122a870be26$var$durationKeys = [
    "duration",
    "bounce"
];
const $0071f122a870be26$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $0071f122a870be26$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $0071f122a870be26$var$getSpringOptions(options) {
    let springOptions = {
        velocity: (0, $0ad6218156594f06$export$86436497e7b05d16).velocity,
        stiffness: (0, $0ad6218156594f06$export$86436497e7b05d16).stiffness,
        damping: (0, $0ad6218156594f06$export$86436497e7b05d16).damping,
        mass: (0, $0ad6218156594f06$export$86436497e7b05d16).mass,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$0071f122a870be26$var$isSpringType(options, $0071f122a870be26$var$physicsKeys) && $0071f122a870be26$var$isSpringType(options, $0071f122a870be26$var$durationKeys)) {
        if (options.visualDuration) {
            const visualDuration = options.visualDuration;
            const root = 2 * Math.PI / (visualDuration * 1.2);
            const stiffness = root * root;
            const damping = 2 * (0, $0c8f57795abc012c$export$7d15b64cf5a3a4c4)(0.05, 1, 1 - options.bounce) * Math.sqrt(stiffness);
            springOptions = {
                ...springOptions,
                mass: (0, $0ad6218156594f06$export$86436497e7b05d16).mass,
                stiffness: stiffness,
                damping: damping
            };
        } else {
            const derived = (0, $a3434a995f8a72f8$export$b15f158dc6d6f458)(options);
            springOptions = {
                ...springOptions,
                ...derived,
                mass: (0, $0ad6218156594f06$export$86436497e7b05d16).mass
            };
            springOptions.isResolvedFromDuration = true;
        }
    }
    return springOptions;
}
function $0071f122a870be26$export$b36281d89752ae66(optionsOrVisualDuration = (0, $0ad6218156594f06$export$86436497e7b05d16).visualDuration, bounce = (0, $0ad6218156594f06$export$86436497e7b05d16).bounce) {
    const options = typeof optionsOrVisualDuration !== "object" ? {
        visualDuration: optionsOrVisualDuration,
        keyframes: [
            0,
            1
        ],
        bounce: bounce
    } : optionsOrVisualDuration;
    let { restSpeed: restSpeed, restDelta: restDelta } = options;
    const origin = options.keyframes[0];
    const target = options.keyframes[options.keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $0071f122a870be26$var$getSpringOptions({
        ...options,
        velocity: -(0, $a20bf34b6c7fb9be$export$f64c3bfbc58eec0f)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $a20bf34b6c7fb9be$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? (0, $0ad6218156594f06$export$86436497e7b05d16).restSpeed.granular : (0, $0ad6218156594f06$export$86436497e7b05d16).restSpeed.default);
    restDelta || (restDelta = isGranularScale ? (0, $0ad6218156594f06$export$86436497e7b05d16).restDelta.granular : (0, $0ad6218156594f06$export$86436497e7b05d16).restDelta.default);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $a3434a995f8a72f8$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    const generator = {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = 0.0;
                /**
                 * We only need to calculate velocity for under-damped springs
                 * as over- and critically-damped springs can't overshoot, so
                 * checking only for displacement is enough.
                 */ if (dampingRatio < 1) currentVelocity = t === 0 ? (0, $a20bf34b6c7fb9be$export$fc3e7e8557f8c8c7)(initialVelocity) : (0, $ba040d3e059872ef$export$854187271d233eb5)(resolveSpring, t, current);
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        },
        toString: ()=>{
            const calculatedDuration = Math.min((0, $22da538acfb87e5a$export$cbdd6b3d40ea54e2)(generator), (0, $22da538acfb87e5a$export$f4ff70a5b4808fd8));
            const easing = (0, $6895d092cec78af0$export$66d3851e2b1ec912)((progress)=>generator.next(calculatedDuration * progress).value, calculatedDuration, 30);
            return calculatedDuration + "ms " + easing;
        }
    };
    return generator;
}




/**
 * Create a progress => progress easing function from a generator.
 */ function $793c912f1b1fdc4e$export$7f1511d09ee75a99(options, scale = 100, createGenerator) {
    const generator = createGenerator({
        ...options,
        keyframes: [
            0,
            scale
        ]
    });
    const duration = Math.min((0, $22da538acfb87e5a$export$cbdd6b3d40ea54e2)(generator), (0, $22da538acfb87e5a$export$f4ff70a5b4808fd8));
    return {
        type: "keyframes",
        ease: (progress)=>generator.next(duration * progress).value / scale,
        duration: (0, $a20bf34b6c7fb9be$export$f64c3bfbc58eec0f)(duration)
    };
}


/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $f9223c1ee75bd9d2$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};



function $e90b5e23bd84e8ed$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $cb0a4d7c7c382e92$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $f9223c1ee75bd9d2$export$3bb0b4ff1037b8dd)(min, 1, offsetProgress));
    }
}


function $496e670188b9fbda$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $e90b5e23bd84e8ed$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}





const $6d518b48081ad760$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);


function $0c77a244908e9355$export$90ceba2564a894f8(elementOrSelector, scope, selectorCache) {
    var _a;
    if (elementOrSelector instanceof Element) return [
        elementOrSelector
    ];
    else if (typeof elementOrSelector === "string") {
        let root = document;
        if (scope) // TODO: Refactor to utils package
        // invariant(
        //     Boolean(scope.current),
        //     "Scope provided, but no element detected."
        // )
        root = scope.current;
        const elements = (_a = selectorCache === null || selectorCache === void 0 ? void 0 : selectorCache[elementOrSelector]) !== null && _a !== void 0 ? _a : root.querySelectorAll(elementOrSelector);
        return elements ? Array.from(elements) : [];
    }
    return Array.from(elementOrSelector);
}


function $82a8db1982ddf415$export$d276bfce3b1077ca(keyframes) {
    return typeof keyframes === "object" && !Array.isArray(keyframes);
}


function $38d9e3b87f69fbe7$export$92b2aefc56600400(subject, keyframes, scope, selectorCache) {
    if (typeof subject === "string" && (0, $82a8db1982ddf415$export$d276bfce3b1077ca)(keyframes)) return (0, $0c77a244908e9355$export$90ceba2564a894f8)(subject, scope, selectorCache);
    else if (subject instanceof NodeList) return Array.from(subject);
    else if (Array.isArray(subject)) return subject;
    else return [
        subject
    ];
}


function $2bf3ea0c6e5a6324$export$6ab7812f1bac68be(type) {
    return typeof type === "function";
}


/**
 * Given a absolute or relative time definition and current/prev time state of the sequence,
 * calculate an absolute time for the next keyframes.
 */ function $adbdd2d7ebe57b0b$export$83ccd85155ba9791(current, next, prev, labels) {
    var _a;
    if (typeof next === "number") return next;
    else if (next.startsWith("-") || next.startsWith("+")) return Math.max(0, current + parseFloat(next));
    else if (next === "<") return prev;
    else return (_a = labels.get(next)) !== null && _a !== void 0 ? _a : current;
}


const $f244e85cda78dd5c$export$4997ffc0176396a6 = (min, max, v)=>{
    const rangeSize = max - min;
    return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
};


const $3132f01cfd2c6d0a$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};


function $0e3751ef154c3a84$export$41c5e731255a462(easing, i) {
    return (0, $3132f01cfd2c6d0a$export$216948827bbdc797)(easing) ? easing[(0, $f244e85cda78dd5c$export$4997ffc0176396a6)(0, easing.length, i)] : easing;
}


function $1a4ec488c9eadfe6$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $1a4ec488c9eadfe6$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $1a4ec488c9eadfe6$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}



function $5a607344247a67e1$export$6f93cdbb78924b88(sequence, startTime, endTime) {
    for(let i = 0; i < sequence.length; i++){
        const keyframe = sequence[i];
        if (keyframe.at > startTime && keyframe.at < endTime) {
            (0, $1a4ec488c9eadfe6$export$fe2d9b4e03920b4c)(sequence, keyframe);
            // If we remove this item we have to push the pointer back one
            i--;
        }
    }
}
function $5a607344247a67e1$export$89dfa6760a9f76e7(sequence, keyframes, easing, offset, startTime, endTime) {
    /**
     * Erase every existing value between currentTime and targetTime,
     * this will essentially splice this timeline into any currently
     * defined ones.
     */ $5a607344247a67e1$export$6f93cdbb78924b88(sequence, startTime, endTime);
    for(let i = 0; i < keyframes.length; i++)sequence.push({
        value: keyframes[i],
        at: (0, $f9223c1ee75bd9d2$export$3bb0b4ff1037b8dd)(startTime, endTime, offset[i]),
        easing: (0, $0e3751ef154c3a84$export$41c5e731255a462)(easing, i)
    });
}


function $8270ce09760126c8$export$66dd3fbf44e05bd9(a, b) {
    if (a.at === b.at) {
        if (a.value === null) return 1;
        if (b.value === null) return -1;
        return 0;
    } else return a.at - b.at;
}



/**
 * Take an array of times that represent repeated keyframes. For instance
 * if we have original times of [0, 0.5, 1] then our repeated times will
 * be [0, 0.5, 1, 1, 1.5, 2]. Loop over the times and scale them back
 * down to a 0-1 scale.
 */ function $60b2abf3ca81bd26$export$989461f373b2c60a(times, repeat) {
    for(let i = 0; i < times.length; i++)times[i] = times[i] / (repeat + 1);
}


function $2bb3c2bb8c91af37$export$fcfa02e469c39006(duration, repeat, _repeatDelay) {
    return duration * (repeat + 1);
}



const $3d9025610d4b57b5$var$defaultSegmentEasing = "easeInOut";
const $3d9025610d4b57b5$var$MAX_REPEAT = 20;
function $3d9025610d4b57b5$export$1f0f44b51a4b2f73(sequence, { defaultTransition: defaultTransition = {}, ...sequenceTransition } = {}, scope, generators) {
    const defaultDuration = defaultTransition.duration || 0.3;
    const animationDefinitions = new Map();
    const sequences = new Map();
    const elementCache = {};
    const timeLabels = new Map();
    let prevTime = 0;
    let currentTime = 0;
    let totalDuration = 0;
    /**
     * Build the timeline by mapping over the sequence array and converting
     * the definitions into keyframes and offsets with absolute time values.
     * These will later get converted into relative offsets in a second pass.
     */ for(let i = 0; i < sequence.length; i++){
        const segment = sequence[i];
        /**
         * If this is a timeline label, mark it and skip the rest of this iteration.
         */ if (typeof segment === "string") {
            timeLabels.set(segment, currentTime);
            continue;
        } else if (!Array.isArray(segment)) {
            timeLabels.set(segment.name, (0, $adbdd2d7ebe57b0b$export$83ccd85155ba9791)(currentTime, segment.at, prevTime, timeLabels));
            continue;
        }
        let [subject, keyframes, transition = {}] = segment;
        /**
         * If a relative or absolute time value has been specified we need to resolve
         * it in relation to the currentTime.
         */ if (transition.at !== undefined) currentTime = (0, $adbdd2d7ebe57b0b$export$83ccd85155ba9791)(currentTime, transition.at, prevTime, timeLabels);
        /**
         * Keep track of the maximum duration in this definition. This will be
         * applied to currentTime once the definition has been parsed.
         */ let maxDuration = 0;
        const resolveValueSequence = (valueKeyframes, valueTransition, valueSequence, elementIndex = 0, numSubjects = 0)=>{
            const valueKeyframesAsList = $3d9025610d4b57b5$var$keyframesAsList(valueKeyframes);
            const { delay: delay = 0, times: times = (0, $496e670188b9fbda$export$24dbcec0b26e6d9d)(valueKeyframesAsList), type: type = "keyframes", repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay = 0, ...remainingTransition } = valueTransition;
            let { ease: ease = defaultTransition.ease || "easeOut", duration: duration } = valueTransition;
            /**
             * Resolve stagger() if defined.
             */ const calculatedDelay = typeof delay === "function" ? delay(elementIndex, numSubjects) : delay;
            /**
             * If this animation should and can use a spring, generate a spring easing function.
             */ const numKeyframes = valueKeyframesAsList.length;
            const createGenerator = (0, $2bf3ea0c6e5a6324$export$6ab7812f1bac68be)(type) ? type : generators === null || generators === void 0 ? void 0 : generators[type];
            if (numKeyframes <= 2 && createGenerator) {
                /**
                 * As we're creating an easing function from a spring,
                 * ideally we want to generate it using the real distance
                 * between the two keyframes. However this isn't always
                 * possible - in these situations we use 0-100.
                 */ let absoluteDelta = 100;
                if (numKeyframes === 2 && $3d9025610d4b57b5$var$isNumberKeyframesArray(valueKeyframesAsList)) {
                    const delta = valueKeyframesAsList[1] - valueKeyframesAsList[0];
                    absoluteDelta = Math.abs(delta);
                }
                const springTransition = {
                    ...remainingTransition
                };
                if (duration !== undefined) springTransition.duration = (0, $a20bf34b6c7fb9be$export$fc3e7e8557f8c8c7)(duration);
                const springEasing = (0, $793c912f1b1fdc4e$export$7f1511d09ee75a99)(springTransition, absoluteDelta, createGenerator);
                ease = springEasing.ease;
                duration = springEasing.duration;
            }
            duration !== null && duration !== void 0 ? duration : duration = defaultDuration;
            const startTime = currentTime + calculatedDelay;
            /**
             * If there's only one time offset of 0, fill in a second with length 1
             */ if (times.length === 1 && times[0] === 0) times[1] = 1;
            /**
             * Fill out if offset if fewer offsets than keyframes
             */ const remainder = times.length - valueKeyframesAsList.length;
            remainder > 0 && (0, $e90b5e23bd84e8ed$export$dafee61230cf05c6)(times, remainder);
            /**
             * If only one value has been set, ie [1], push a null to the start of
             * the keyframe array. This will let us mark a keyframe at this point
             * that will later be hydrated with the previous value.
             */ valueKeyframesAsList.length === 1 && valueKeyframesAsList.unshift(null);
            /**
             * Handle repeat options
             */ if (repeat) {
                (0, $ee01c60b140b7aca$export$f5708dca728d7177)(repeat < $3d9025610d4b57b5$var$MAX_REPEAT, "Repeat count too high, must be less than 20");
                duration = (0, $2bb3c2bb8c91af37$export$fcfa02e469c39006)(duration, repeat);
                const originalKeyframes = [
                    ...valueKeyframesAsList
                ];
                const originalTimes = [
                    ...times
                ];
                ease = Array.isArray(ease) ? [
                    ...ease
                ] : [
                    ease
                ];
                const originalEase = [
                    ...ease
                ];
                for(let repeatIndex = 0; repeatIndex < repeat; repeatIndex++){
                    valueKeyframesAsList.push(...originalKeyframes);
                    for(let keyframeIndex = 0; keyframeIndex < originalKeyframes.length; keyframeIndex++){
                        times.push(originalTimes[keyframeIndex] + (repeatIndex + 1));
                        ease.push(keyframeIndex === 0 ? "linear" : (0, $0e3751ef154c3a84$export$41c5e731255a462)(originalEase, keyframeIndex - 1));
                    }
                }
                (0, $60b2abf3ca81bd26$export$989461f373b2c60a)(times, repeat);
            }
            const targetTime = startTime + duration;
            /**
             * Add keyframes, mapping offsets to absolute time.
             */ (0, $5a607344247a67e1$export$89dfa6760a9f76e7)(valueSequence, valueKeyframesAsList, ease, times, startTime, targetTime);
            maxDuration = Math.max(calculatedDelay + duration, maxDuration);
            totalDuration = Math.max(targetTime, totalDuration);
        };
        if ((0, $6d518b48081ad760$export$605d60a2578142d3)(subject)) {
            const subjectSequence = $3d9025610d4b57b5$var$getSubjectSequence(subject, sequences);
            resolveValueSequence(keyframes, transition, $3d9025610d4b57b5$var$getValueSequence("default", subjectSequence));
        } else {
            const subjects = (0, $38d9e3b87f69fbe7$export$92b2aefc56600400)(subject, keyframes, scope, elementCache);
            const numSubjects = subjects.length;
            /**
             * For every element in this segment, process the defined values.
             */ for(let subjectIndex = 0; subjectIndex < numSubjects; subjectIndex++){
                /**
                 * Cast necessary, but we know these are of this type
                 */ keyframes;
                transition;
                const thisSubject = subjects[subjectIndex];
                const subjectSequence = $3d9025610d4b57b5$var$getSubjectSequence(thisSubject, sequences);
                for(const key in keyframes)resolveValueSequence(keyframes[key], $3d9025610d4b57b5$export$7c1391340308742e(transition, key), $3d9025610d4b57b5$var$getValueSequence(key, subjectSequence), subjectIndex, numSubjects);
            }
        }
        prevTime = currentTime;
        currentTime += maxDuration;
    }
    /**
     * For every element and value combination create a new animation.
     */ sequences.forEach((valueSequences, element)=>{
        for(const key in valueSequences){
            const valueSequence = valueSequences[key];
            /**
             * Arrange all the keyframes in ascending time order.
             */ valueSequence.sort((0, $8270ce09760126c8$export$66dd3fbf44e05bd9));
            const keyframes = [];
            const valueOffset = [];
            const valueEasing = [];
            /**
             * For each keyframe, translate absolute times into
             * relative offsets based on the total duration of the timeline.
             */ for(let i = 0; i < valueSequence.length; i++){
                const { at: at, value: value, easing: easing } = valueSequence[i];
                keyframes.push(value);
                valueOffset.push((0, $cb0a4d7c7c382e92$export$504d7abb21fa8c9)(0, totalDuration, at));
                valueEasing.push(easing || "easeOut");
            }
            /**
             * If the first keyframe doesn't land on offset: 0
             * provide one by duplicating the initial keyframe. This ensures
             * it snaps to the first keyframe when the animation starts.
             */ if (valueOffset[0] !== 0) {
                valueOffset.unshift(0);
                keyframes.unshift(keyframes[0]);
                valueEasing.unshift($3d9025610d4b57b5$var$defaultSegmentEasing);
            }
            /**
             * If the last keyframe doesn't land on offset: 1
             * provide one with a null wildcard value. This will ensure it
             * stays static until the end of the animation.
             */ if (valueOffset[valueOffset.length - 1] !== 1) {
                valueOffset.push(1);
                keyframes.push(null);
            }
            if (!animationDefinitions.has(element)) animationDefinitions.set(element, {
                keyframes: {},
                transition: {}
            });
            const definition = animationDefinitions.get(element);
            definition.keyframes[key] = keyframes;
            definition.transition[key] = {
                ...defaultTransition,
                duration: totalDuration,
                ease: valueEasing,
                times: valueOffset,
                ...sequenceTransition
            };
        }
    });
    return animationDefinitions;
}
function $3d9025610d4b57b5$var$getSubjectSequence(subject, sequences) {
    !sequences.has(subject) && sequences.set(subject, {});
    return sequences.get(subject);
}
function $3d9025610d4b57b5$var$getValueSequence(name, sequences) {
    if (!sequences[name]) sequences[name] = [];
    return sequences[name];
}
function $3d9025610d4b57b5$var$keyframesAsList(keyframes) {
    return Array.isArray(keyframes) ? keyframes : [
        keyframes
    ];
}
function $3d9025610d4b57b5$export$7c1391340308742e(transition, key) {
    return transition && transition[key] ? {
        ...transition,
        ...transition[key]
    } : {
        ...transition
    };
}
const $3d9025610d4b57b5$var$isNumber = (keyframe)=>typeof keyframe === "number";
const $3d9025610d4b57b5$var$isNumberKeyframesArray = (keyframes)=>keyframes.every($3d9025610d4b57b5$var$isNumber);



const $6c06a4cd41166f69$export$bc2a978a17abfdde = new WeakMap();



/**
 * Generate a list of every possible transform key.
 */ const $703b4bcf0b7f8381$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $703b4bcf0b7f8381$export$7b42a0094fb00b6e = new Set($703b4bcf0b7f8381$export$280dc01950909d86);




const $e57734ee27140fe9$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $e57734ee27140fe9$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $e57734ee27140fe9$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $e57734ee27140fe9$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $e57734ee27140fe9$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $e57734ee27140fe9$var$keyframesTransition;
    else if ((0, $703b4bcf0b7f8381$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $e57734ee27140fe9$var$criticallyDampedSpring(keyframes[1]) : $e57734ee27140fe9$var$underDampedSpring;
    return $e57734ee27140fe9$var$ease;
};


function $e4954370239e76c9$export$7c1391340308742e(transition, key) {
    return transition ? transition[key] || transition["default"] || transition : undefined;
}


const $c0fc7f8d5f614817$export$dd826089e3c5e502 = {
    skipAnimations: false,
    useManualTiming: false
};


const $190bc1bbe58c023a$export$888a3d84909f9e3d = {
    current: false
};


const $bfa7d90c3370aa25$var$isNotNull = (value)=>value !== null;
function $bfa7d90c3370aa25$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($bfa7d90c3370aa25$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}





function $7068bdeb075ec380$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (!queue.has(callback)) queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            // Clear the frame so no callbacks remain. This is to avoid
            // memory leaks should this render step not run for a while.
            thisFrame.clear();
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $c83f4f5a8bcadeb0$export$71ecace0a033b35a = [
    "read",
    "resolveKeyframes",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $c83f4f5a8bcadeb0$var$maxElapsed = 40;
function $c83f4f5a8bcadeb0$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = $c83f4f5a8bcadeb0$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $7068bdeb075ec380$export$b995e5e85f5c8289)(flagRunNextFrame);
        return acc;
    }, {});
    const { read: read, resolveKeyframes: resolveKeyframes, update: update, preRender: preRender, render: render, postRender: postRender } = steps;
    const processBatch = ()=>{
        const timestamp = (0, $c0fc7f8d5f614817$export$dd826089e3c5e502).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $c83f4f5a8bcadeb0$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        read.process(state);
        resolveKeyframes.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $c83f4f5a8bcadeb0$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < $c83f4f5a8bcadeb0$export$71ecace0a033b35a.length; i++)steps[$c83f4f5a8bcadeb0$export$71ecace0a033b35a[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $4758d27de84673ea$export$2cef06c20297c17d, cancel: $4758d27de84673ea$export$ec99c0ef4978dccb, state: $4758d27de84673ea$export$fff89137e9e818ce, steps: $4758d27de84673ea$export$1811c3a7e3af92f0 } = (0, $c83f4f5a8bcadeb0$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $b971a0c42800d23e$export$8793edee2d425525), true);




/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $76eea01c2eb9fa36$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $76eea01c2eb9fa36$var$subdivisionPrecision = 0.0000001;
const $76eea01c2eb9fa36$var$subdivisionMaxIterations = 12;
function $76eea01c2eb9fa36$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $76eea01c2eb9fa36$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $76eea01c2eb9fa36$var$subdivisionPrecision && ++i < $76eea01c2eb9fa36$var$subdivisionMaxIterations);
    return currentT;
}
function $76eea01c2eb9fa36$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $b971a0c42800d23e$export$8793edee2d425525;
    const getTForX = (aX)=>$76eea01c2eb9fa36$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $76eea01c2eb9fa36$var$calcBezier(getTForX(t), mY1, mY2);
}


// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $6d724b1289e09273$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $5acfb3fb7849de43$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $15e1d000a158db8b$export$77edfce482316a60 = /*@__PURE__*/ (0, $76eea01c2eb9fa36$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $15e1d000a158db8b$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $5acfb3fb7849de43$export$2c07eeff45156d4d)($15e1d000a158db8b$export$77edfce482316a60);
const $15e1d000a158db8b$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $6d724b1289e09273$export$f946554fb8aeaf0d)($15e1d000a158db8b$export$b01116c84cdfe1a2);


const $3f0ae1983c3701f3$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $15e1d000a158db8b$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));





const $f21058ca353e4e4a$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $f21058ca353e4e4a$export$c8d67a19199d1a50 = (0, $5acfb3fb7849de43$export$2c07eeff45156d4d)($f21058ca353e4e4a$export$e444123e42d03385);
const $f21058ca353e4e4a$export$30d3455eee55bed5 = (0, $6d724b1289e09273$export$f946554fb8aeaf0d)($f21058ca353e4e4a$export$e444123e42d03385);


/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $057e65c4a62bce07$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);


function $2afacd74f3be8fd0$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $057e65c4a62bce07$export$ade84c85e44a6cb1)(value);
    else return true;
}



/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $dc2715baad060b2c$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);


const $f5a014041f41ad31$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $f5a014041f41ad31$export$9de1236619d9e756 = /*@__PURE__*/ $f5a014041f41ad31$var$checkStringStartsWith("--");
const $f5a014041f41ad31$var$startsAsVariableToken = /*@__PURE__*/ $f5a014041f41ad31$var$checkStringStartsWith("var(--");
const $f5a014041f41ad31$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $f5a014041f41ad31$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $f5a014041f41ad31$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $f5a014041f41ad31$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;


/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $00d76357269ae0a3$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $00d76357269ae0a3$export$b9f0c1f373aee2b0(current) {
    const match = $00d76357269ae0a3$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 !== null && token1 !== void 0 ? token1 : token2}`,
        fallback
    ];
}
const $00d76357269ae0a3$var$maxDepth = 4;
function $00d76357269ae0a3$export$289398774300c991(current, element, depth = 1) {
    (0, $ee01c60b140b7aca$export$f5708dca728d7177)(depth <= $00d76357269ae0a3$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $00d76357269ae0a3$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $dc2715baad060b2c$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $f5a014041f41ad31$export$31f9caa2600b5723)(fallback) ? $00d76357269ae0a3$export$289398774300c991(fallback, element, depth + 1) : fallback;
}





const $fdc943b614c75d99$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $fdc943b614c75d99$export$58f0f39f63f3cf42 = {
    ...$fdc943b614c75d99$export$98e628dec113755e,
    transform: (v)=>(0, $0c8f57795abc012c$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $fdc943b614c75d99$export$dcdf75081b88279d = {
    ...$fdc943b614c75d99$export$98e628dec113755e,
    default: 1
};


const $55eef29d1f3b7d7e$var$createUnitType = (unit)=>({
        test: (v)=>typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $55eef29d1f3b7d7e$export$41fc368e1a942b97 = /*@__PURE__*/ $55eef29d1f3b7d7e$var$createUnitType("deg");
const $55eef29d1f3b7d7e$export$626336c2cd4b14de = /*@__PURE__*/ $55eef29d1f3b7d7e$var$createUnitType("%");
const $55eef29d1f3b7d7e$export$91c0eda1d06bf008 = /*@__PURE__*/ $55eef29d1f3b7d7e$var$createUnitType("px");
const $55eef29d1f3b7d7e$export$f91e8c45a95a32f2 = /*@__PURE__*/ $55eef29d1f3b7d7e$var$createUnitType("vh");
const $55eef29d1f3b7d7e$export$aed3d7b7d206c196 = /*@__PURE__*/ $55eef29d1f3b7d7e$var$createUnitType("vw");
const $55eef29d1f3b7d7e$export$44e2e1705876d7ed = {
    ...$55eef29d1f3b7d7e$export$626336c2cd4b14de,
    parse: (v)=>$55eef29d1f3b7d7e$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$55eef29d1f3b7d7e$export$626336c2cd4b14de.transform(v * 100)
};


const $dc61c857057cefea$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const $dc61c857057cefea$export$8e5250d1aa9bf370 = (v)=>v === (0, $fdc943b614c75d99$export$98e628dec113755e) || v === (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008);
const $dc61c857057cefea$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $dc61c857057cefea$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/u);
        if (matrix3d) return $dc61c857057cefea$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/u);
            if (matrix) return $dc61c857057cefea$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $dc61c857057cefea$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $dc61c857057cefea$var$nonTranslationalTransformKeys = (0, $703b4bcf0b7f8381$export$280dc01950909d86).filter((key)=>!$dc61c857057cefea$var$transformKeys.has(key));
function $dc61c857057cefea$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $dc61c857057cefea$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $dc61c857057cefea$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $dc61c857057cefea$var$getTranslateFromMatrix(4, 13),
    y: $dc61c857057cefea$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$dc61c857057cefea$export$781d46a8aa670d52.translateX = $dc61c857057cefea$export$781d46a8aa670d52.x;
$dc61c857057cefea$export$781d46a8aa670d52.translateY = $dc61c857057cefea$export$781d46a8aa670d52.y;




/**
 * Tests a provided value against a ValueType
 */ const $7a46dcf899ee8d83$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $f01a90ce376cd553$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $a6dbbf483881cd85$export$d176691c1998a1f5 = [
    (0, $fdc943b614c75d99$export$98e628dec113755e),
    (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    (0, $55eef29d1f3b7d7e$export$626336c2cd4b14de),
    (0, $55eef29d1f3b7d7e$export$41fc368e1a942b97),
    (0, $55eef29d1f3b7d7e$export$aed3d7b7d206c196),
    (0, $55eef29d1f3b7d7e$export$f91e8c45a95a32f2),
    (0, $f01a90ce376cd553$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $a6dbbf483881cd85$export$eefdd52e3ccae428 = (v)=>$a6dbbf483881cd85$export$d176691c1998a1f5.find((0, $7a46dcf899ee8d83$export$6eae4d0a6a7ca7cd)(v));




const $74b30abfb1c5ca65$var$toResolve = new Set();
let $74b30abfb1c5ca65$var$isScheduled = false;
let $74b30abfb1c5ca65$var$anyNeedsMeasurement = false;
function $74b30abfb1c5ca65$var$measureAllKeyframes() {
    if ($74b30abfb1c5ca65$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($74b30abfb1c5ca65$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $dc61c857057cefea$export$39d4bc9655f3f632)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                var _a;
                (_a = element.getValue(key)) === null || _a === void 0 || _a.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $74b30abfb1c5ca65$var$anyNeedsMeasurement = false;
    $74b30abfb1c5ca65$var$isScheduled = false;
    $74b30abfb1c5ca65$var$toResolve.forEach((resolver)=>resolver.complete());
    $74b30abfb1c5ca65$var$toResolve.clear();
}
function $74b30abfb1c5ca65$var$readAllKeyframes() {
    $74b30abfb1c5ca65$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $74b30abfb1c5ca65$var$anyNeedsMeasurement = true;
    });
}
function $74b30abfb1c5ca65$export$78b96d2a12593b05() {
    $74b30abfb1c5ca65$var$readAllKeyframes();
    $74b30abfb1c5ca65$var$measureAllKeyframes();
}
class $74b30abfb1c5ca65$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        /**
         * Track whether this resolver has completed. Once complete, it never
         * needs to attempt keyframe resolution again.
         */ this.isComplete = false;
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        /**
         * Track whether this resolver is currently scheduled to resolve
         * to allow it to be cancelled and resumed externally.
         */ this.isScheduled = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.isScheduled = true;
        if (this.isAsync) {
            $74b30abfb1c5ca65$var$toResolve.add(this);
            if (!$74b30abfb1c5ca65$var$isScheduled) {
                $74b30abfb1c5ca65$var$isScheduled = true;
                (0, $4758d27de84673ea$export$2cef06c20297c17d).read($74b30abfb1c5ca65$var$readAllKeyframes);
                (0, $4758d27de84673ea$export$2cef06c20297c17d).resolveKeyframes($74b30abfb1c5ca65$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        /**
         * If a keyframe is null, we hydrate it either by reading it from
         * the instance, or propagating from previous keyframes.
         */ for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null) {
            /**
                 * If the first keyframe is null, we need to find its value by sampling the element
                 */ if (i === 0) {
                const currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
                const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
                else if (element && name) {
                    const valueAsRead = element.readValue(name, finalKeyframe);
                    if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
                }
                if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
                if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
            } else unresolvedKeyframes[i] = unresolvedKeyframes[i - 1];
        }
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete() {
        this.isComplete = true;
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
        $74b30abfb1c5ca65$var$toResolve.delete(this);
    }
    cancel() {
        if (!this.isComplete) {
            this.isScheduled = false;
            $74b30abfb1c5ca65$var$toResolve.delete(this);
        }
    }
    resume() {
        if (!this.isComplete) this.scheduleResolve();
    }
}




// If this number is a decimal, make it just five decimal places
// to avoid exponents
const $e9d8d8443d2fad1a$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;


const $e0ecc42e7e111f40$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;


function $dd449037292b0b32$export$b931b78cbb3caf86(v) {
    return v == null;
}


const $bf8bc5ce82c025a8$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;


/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $07c9e3ec36cfa0d4$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean(typeof v === "string" && (0, $bf8bc5ce82c025a8$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && !(0, $dd449037292b0b32$export$b931b78cbb3caf86)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $07c9e3ec36cfa0d4$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (typeof v !== "string") return v;
        const [a, b, c, alpha] = v.match((0, $e0ecc42e7e111f40$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $e5f666cc69ba56fe$var$clampRgbUnit = (v)=>(0, $0c8f57795abc012c$export$7d15b64cf5a3a4c4)(0, 255, v);
const $e5f666cc69ba56fe$export$7a99c86b5b1f4c9e = {
    ...(0, $fdc943b614c75d99$export$98e628dec113755e),
    transform: (v)=>Math.round($e5f666cc69ba56fe$var$clampRgbUnit(v))
};
const $e5f666cc69ba56fe$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $07c9e3ec36cfa0d4$export$2c8400d58aca05e)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $07c9e3ec36cfa0d4$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $e5f666cc69ba56fe$export$7a99c86b5b1f4c9e.transform(red) + ", " + $e5f666cc69ba56fe$export$7a99c86b5b1f4c9e.transform(green) + ", " + $e5f666cc69ba56fe$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $e9d8d8443d2fad1a$export$83d2e9e3e4ee39ed)((0, $fdc943b614c75d99$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $8d3586a0230ee83c$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $8d3586a0230ee83c$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $07c9e3ec36cfa0d4$export$2c8400d58aca05e)("#"),
    parse: $8d3586a0230ee83c$var$parseHex,
    transform: (0, $e5f666cc69ba56fe$export$4e46ac54fc82cf3b).transform
};






const $5d13bfbdbf849b86$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $07c9e3ec36cfa0d4$export$2c8400d58aca05e)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $07c9e3ec36cfa0d4$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $55eef29d1f3b7d7e$export$626336c2cd4b14de).transform((0, $e9d8d8443d2fad1a$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $55eef29d1f3b7d7e$export$626336c2cd4b14de).transform((0, $e9d8d8443d2fad1a$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $e9d8d8443d2fad1a$export$83d2e9e3e4ee39ed)((0, $fdc943b614c75d99$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $9c8ccc3d2a8382a3$export$35e9368ef982300f = {
    test: (v)=>(0, $e5f666cc69ba56fe$export$4e46ac54fc82cf3b).test(v) || (0, $8d3586a0230ee83c$export$834dfc94dde4b3d8).test(v) || (0, $5d13bfbdbf849b86$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $e5f666cc69ba56fe$export$4e46ac54fc82cf3b).test(v)) return (0, $e5f666cc69ba56fe$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $5d13bfbdbf849b86$export$810b04175080204c).test(v)) return (0, $5d13bfbdbf849b86$export$810b04175080204c).parse(v);
        else return (0, $8d3586a0230ee83c$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, $e5f666cc69ba56fe$export$4e46ac54fc82cf3b).transform(v) : (0, $5d13bfbdbf849b86$export$810b04175080204c).transform(v);
    }
};


const $e5a3729682e09d6a$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;




function $40298161d380ddb8$var$test(v) {
    var _a, _b;
    return isNaN(v) && typeof v === "string" && (((_a = v.match((0, $e0ecc42e7e111f40$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $e5a3729682e09d6a$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $40298161d380ddb8$var$NUMBER_TOKEN = "number";
const $40298161d380ddb8$var$COLOR_TOKEN = "color";
const $40298161d380ddb8$var$VAR_TOKEN = "var";
const $40298161d380ddb8$var$VAR_FUNCTION_TOKEN = "var(";
const $40298161d380ddb8$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $40298161d380ddb8$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $40298161d380ddb8$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($40298161d380ddb8$var$complexRegex, (parsedValue)=>{
        if ((0, $9c8ccc3d2a8382a3$export$35e9368ef982300f).test(parsedValue)) {
            indexes.color.push(i);
            types.push($40298161d380ddb8$var$COLOR_TOKEN);
            values.push((0, $9c8ccc3d2a8382a3$export$35e9368ef982300f).parse(parsedValue));
        } else if (parsedValue.startsWith($40298161d380ddb8$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($40298161d380ddb8$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($40298161d380ddb8$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $40298161d380ddb8$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($40298161d380ddb8$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $40298161d380ddb8$var$parseComplexValue(v) {
    return $40298161d380ddb8$export$b61fc7c44bf646d5(v).values;
}
function $40298161d380ddb8$var$createTransformer(source) {
    const { split: split, types: types } = $40298161d380ddb8$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $40298161d380ddb8$var$NUMBER_TOKEN) output += (0, $e9d8d8443d2fad1a$export$83d2e9e3e4ee39ed)(v[i]);
                else if (type === $40298161d380ddb8$var$COLOR_TOKEN) output += (0, $9c8ccc3d2a8382a3$export$35e9368ef982300f).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $40298161d380ddb8$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $40298161d380ddb8$var$getAnimatableNone(v) {
    const parsed = $40298161d380ddb8$var$parseComplexValue(v);
    const transformer = $40298161d380ddb8$var$createTransformer(v);
    return transformer(parsed.map($40298161d380ddb8$var$convertNumbersToZero));
}
const $40298161d380ddb8$export$83a0e34f1302825b = {
    test: $40298161d380ddb8$var$test,
    parse: $40298161d380ddb8$var$parseComplexValue,
    createTransformer: $40298161d380ddb8$var$createTransformer,
    getAnimatableNone: $40298161d380ddb8$var$getAnimatableNone
};





/**
 * Properties that should default to 1 or 100%
 */ const $f1241c3641356a97$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $f1241c3641356a97$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $e0ecc42e7e111f40$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $f1241c3641356a97$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $f1241c3641356a97$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $f1241c3641356a97$export$3dea766d36a8935f = {
    ...(0, $40298161d380ddb8$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($f1241c3641356a97$var$functionRegex);
        return functions ? functions.map($f1241c3641356a97$var$applyDefaultFilter).join(" ") : v;
    }
};







const $0bc5079cd6e0fd57$export$2fb74b0a4e7d7c4a = {
    // Border props
    borderWidth: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    borderTopWidth: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    borderRightWidth: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    borderRadius: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    radius: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    maxWidth: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    height: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    maxHeight: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    top: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    right: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    bottom: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    left: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    paddingTop: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    paddingRight: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    paddingBottom: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    paddingLeft: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    margin: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    marginTop: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    marginRight: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    marginBottom: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    marginLeft: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    // Misc
    backgroundPositionX: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    backgroundPositionY: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008)
};




const $0461e305f176aa04$export$f2e4285fee37e26 = {
    rotate: (0, $55eef29d1f3b7d7e$export$41fc368e1a942b97),
    rotateX: (0, $55eef29d1f3b7d7e$export$41fc368e1a942b97),
    rotateY: (0, $55eef29d1f3b7d7e$export$41fc368e1a942b97),
    rotateZ: (0, $55eef29d1f3b7d7e$export$41fc368e1a942b97),
    scale: $fdc943b614c75d99$export$dcdf75081b88279d,
    scaleX: (0, $fdc943b614c75d99$export$dcdf75081b88279d),
    scaleY: (0, $fdc943b614c75d99$export$dcdf75081b88279d),
    scaleZ: (0, $fdc943b614c75d99$export$dcdf75081b88279d),
    skew: (0, $55eef29d1f3b7d7e$export$41fc368e1a942b97),
    skewX: (0, $55eef29d1f3b7d7e$export$41fc368e1a942b97),
    skewY: (0, $55eef29d1f3b7d7e$export$41fc368e1a942b97),
    distance: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    translateX: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    translateY: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    translateZ: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    x: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    y: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    z: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    perspective: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    transformPerspective: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    opacity: (0, $fdc943b614c75d99$export$58f0f39f63f3cf42),
    originX: (0, $55eef29d1f3b7d7e$export$44e2e1705876d7ed),
    originY: (0, $55eef29d1f3b7d7e$export$44e2e1705876d7ed),
    originZ: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008)
};



const $872dfb4e99033b14$export$7d260a2a5f8bc19e = {
    ...(0, $fdc943b614c75d99$export$98e628dec113755e),
    transform: Math.round
};


const $1981f705a943c01a$export$eec14432cd1cb67b = {
    ...(0, $0bc5079cd6e0fd57$export$2fb74b0a4e7d7c4a),
    ...(0, $0461e305f176aa04$export$f2e4285fee37e26),
    zIndex: (0, $872dfb4e99033b14$export$7d260a2a5f8bc19e),
    size: (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008),
    // SVG
    fillOpacity: (0, $fdc943b614c75d99$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $fdc943b614c75d99$export$58f0f39f63f3cf42),
    numOctaves: (0, $872dfb4e99033b14$export$7d260a2a5f8bc19e)
};


/**
 * A map of default value types for common values
 */ const $14b8677d55ad0a7c$export$98cd7c72c5a731fb = {
    ...(0, $1981f705a943c01a$export$eec14432cd1cb67b),
    color: // Color props
    $9c8ccc3d2a8382a3$export$35e9368ef982300f,
    backgroundColor: (0, $9c8ccc3d2a8382a3$export$35e9368ef982300f),
    outlineColor: (0, $9c8ccc3d2a8382a3$export$35e9368ef982300f),
    fill: (0, $9c8ccc3d2a8382a3$export$35e9368ef982300f),
    stroke: (0, $9c8ccc3d2a8382a3$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $9c8ccc3d2a8382a3$export$35e9368ef982300f),
    borderTopColor: (0, $9c8ccc3d2a8382a3$export$35e9368ef982300f),
    borderRightColor: (0, $9c8ccc3d2a8382a3$export$35e9368ef982300f),
    borderBottomColor: (0, $9c8ccc3d2a8382a3$export$35e9368ef982300f),
    borderLeftColor: (0, $9c8ccc3d2a8382a3$export$35e9368ef982300f),
    filter: $f1241c3641356a97$export$3dea766d36a8935f,
    WebkitFilter: (0, $f1241c3641356a97$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $14b8677d55ad0a7c$export$67d1babe0338d23b = (key)=>$14b8677d55ad0a7c$export$98cd7c72c5a731fb[key];


function $4adf6409e3ad163d$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $14b8677d55ad0a7c$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $f1241c3641356a97$export$3dea766d36a8935f)) defaultValueType = (0, $40298161d380ddb8$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}


/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $e259b91c6760f63f$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $e259b91c6760f63f$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$e259b91c6760f63f$var$invalidTemplates.has(keyframe) && (0, $40298161d380ddb8$export$b61fc7c44bf646d5)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $4adf6409e3ad163d$export$cea0cedcb94873b5)(name, animatableTemplate);
}


class $7a8f8b7884b040ae$export$4983792d11b61017 extends (0, $74b30abfb1c5ca65$export$74d34ca3182f1750) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $f5a014041f41ad31$export$31f9caa2600b5723)(keyframe)) {
                    const resolved = (0, $00d76357269ae0a3$export$289398774300c991)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $dc61c857057cefea$export$c66c0d5db2a205d).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $a6dbbf483881cd85$export$eefdd52e3ccae428)(origin);
        const targetType = (0, $a6dbbf483881cd85$export$eefdd52e3ccae428)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $dc61c857057cefea$export$8e5250d1aa9bf370)(originType) && (0, $dc61c857057cefea$export$8e5250d1aa9bf370)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if ((0, $2afacd74f3be8fd0$export$e56af863d5645d5f)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $e259b91c6760f63f$export$8cc4958f8e540f37)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $dc61c857057cefea$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        var _a;
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $dc61c857057cefea$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if ((_a = this.removedTransforms) === null || _a === void 0 ? void 0 : _a.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}








let $92548cb66fe736dd$var$now;
function $92548cb66fe736dd$var$clearTime() {
    $92548cb66fe736dd$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $92548cb66fe736dd$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($92548cb66fe736dd$var$now === undefined) $92548cb66fe736dd$export$2da9be4cfdb689b1.set((0, $4758d27de84673ea$export$fff89137e9e818ce).isProcessing || (0, $c0fc7f8d5f614817$export$dd826089e3c5e502).useManualTiming ? (0, $4758d27de84673ea$export$fff89137e9e818ce).timestamp : performance.now());
        return $92548cb66fe736dd$var$now;
    },
    set: (newTime)=>{
        $92548cb66fe736dd$var$now = newTime;
        queueMicrotask($92548cb66fe736dd$var$clearTime);
    }
};







/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $815f09a6022028d9$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $40298161d380ddb8$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};


function $c2e24f86b98cd9d9$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $c2e24f86b98cd9d9$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $815f09a6022028d9$export$65676b58b122bc38)(originKeyframe, name);
    const isTargetAnimatable = (0, $815f09a6022028d9$export$65676b58b122bc38)(targetKeyframe, name);
    (0, $ee01c60b140b7aca$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $c2e24f86b98cd9d9$var$hasKeyframesChanged(keyframes) || (type === "spring" || (0, $2bf3ea0c6e5a6324$export$6ab7812f1bac68be)(type)) && velocity;
}



/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const $6c958fe978f62ea5$var$MAX_RESOLVE_DELAY = 40;
class $6c958fe978f62ea5$export$d1e4f34b9c2550c1 {
    constructor({ autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", ...options }){
        // Track whether the animation has been stopped. Stopped animations won't restart.
        this.isStopped = false;
        this.hasAttemptedResolve = false;
        this.createdAt = (0, $92548cb66fe736dd$export$2da9be4cfdb689b1).now();
        this.options = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            ...options
        };
        this.updateFinishedPromise();
    }
    /**
     * This method uses the createdAt and resolvedAt to calculate the
     * animation startTime. *Ideally*, we would use the createdAt time as t=0
     * as the following frame would then be the first frame of the animation in
     * progress, which would feel snappier.
     *
     * However, if there's a delay (main thread work) between the creation of
     * the animation and the first commited frame, we prefer to use resolvedAt
     * to avoid a sudden jump into the animation.
     */ calcStartTime() {
        if (!this.resolvedAt) return this.createdAt;
        return this.resolvedAt - this.createdAt > $6c958fe978f62ea5$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt;
    }
    /**
     * A getter for resolved data. If keyframes are not yet resolved, accessing
     * this.resolved will synchronously flush all pending keyframe resolvers.
     * This is a deoptimisation, but at its worst still batches read/writes.
     */ get resolved() {
        if (!this._resolved && !this.hasAttemptedResolve) (0, $74b30abfb1c5ca65$export$78b96d2a12593b05)();
        return this._resolved;
    }
    /**
     * A method to be called when the keyframes resolver completes. This method
     * will check if its possible to run the animation and, if not, skip it.
     * Otherwise, it will call initPlayback on the implementing class.
     */ onKeyframesResolved(keyframes, finalKeyframe) {
        this.resolvedAt = (0, $92548cb66fe736dd$export$2da9be4cfdb689b1).now();
        this.hasAttemptedResolve = true;
        const { name: name, type: type, velocity: velocity, delay: delay, onComplete: onComplete, onUpdate: onUpdate, isGenerator: isGenerator } = this.options;
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!isGenerator && !(0, $c2e24f86b98cd9d9$export$1b109e6c9968df4f)(keyframes, name, type, velocity)) {
            // Finish immediately
            if ((0, $190bc1bbe58c023a$export$888a3d84909f9e3d).current || !delay) {
                onUpdate === null || onUpdate === void 0 || onUpdate((0, $bfa7d90c3370aa25$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
                onComplete === null || onComplete === void 0 || onComplete();
                this.resolveFinishedPromise();
                return;
            } else this.options.duration = 0;
        }
        const resolvedAnimation = this.initPlayback(keyframes, finalKeyframe);
        if (resolvedAnimation === false) return;
        this._resolved = {
            keyframes: keyframes,
            finalKeyframe: finalKeyframe,
            ...resolvedAnimation
        };
        this.onPostResolved();
    }
    onPostResolved() {}
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.currentFinishedPromise.then(resolve, reject);
    }
    flatten() {
        this.options.type = "keyframes";
        this.options.ease = "linear";
    }
    updateFinishedPromise() {
        this.currentFinishedPromise = new Promise((resolve)=>{
            this.resolveFinishedPromise = resolve;
        });
    }
}






function $b8e71a46129480ee$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $0071f122a870be26$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $ba040d3e059872ef$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



const $c97dfae3fbc87913$export$929e5a82286172a6 = /*@__PURE__*/ (0, $76eea01c2eb9fa36$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $c97dfae3fbc87913$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $76eea01c2eb9fa36$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $c97dfae3fbc87913$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $76eea01c2eb9fa36$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);










const $3a6a3225e430b117$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


const $0388414a5f74d827$var$easingLookup = {
    linear: (0, $b971a0c42800d23e$export$8793edee2d425525),
    easeIn: $c97dfae3fbc87913$export$929e5a82286172a6,
    easeInOut: $c97dfae3fbc87913$export$c07234257a03d5e9,
    easeOut: $c97dfae3fbc87913$export$57636bb43b1ccbb0,
    circIn: $f21058ca353e4e4a$export$e444123e42d03385,
    circInOut: $f21058ca353e4e4a$export$30d3455eee55bed5,
    circOut: $f21058ca353e4e4a$export$c8d67a19199d1a50,
    backIn: $15e1d000a158db8b$export$b01116c84cdfe1a2,
    backInOut: $15e1d000a158db8b$export$ddc5fd596f6c71b2,
    backOut: $15e1d000a158db8b$export$77edfce482316a60,
    anticipate: $3f0ae1983c3701f3$export$6b0af63b873d419e
};
const $0388414a5f74d827$export$ef97fe084f156ca4 = (definition)=>{
    if ((0, $3a6a3225e430b117$export$ff43f99925d7366b)(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $ee01c60b140b7aca$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $76eea01c2eb9fa36$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $ee01c60b140b7aca$export$f5708dca728d7177)($0388414a5f74d827$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $0388414a5f74d827$var$easingLookup[definition];
    }
    return definition;
};



/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $318e0284607805bc$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $318e0284607805bc$export$a4627e546088548d = (...transformers)=>transformers.reduce($318e0284607805bc$var$combineFunctions);








// Adapted from https://gist.github.com/mjackson/5311256
function $674c258fc0d9ff59$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $674c258fc0d9ff59$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $674c258fc0d9ff59$var$hueToRgb(p, q, hue + 1 / 3);
        green = $674c258fc0d9ff59$var$hueToRgb(p, q, hue);
        blue = $674c258fc0d9ff59$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





function $2682c8e5db4ec62c$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}


// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $0c36e62e136cd5f2$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $0c36e62e136cd5f2$var$colorTypes = [
    (0, $8d3586a0230ee83c$export$834dfc94dde4b3d8),
    (0, $e5f666cc69ba56fe$export$4e46ac54fc82cf3b),
    (0, $5d13bfbdbf849b86$export$810b04175080204c)
];
const $0c36e62e136cd5f2$var$getColorType = (v)=>$0c36e62e136cd5f2$var$colorTypes.find((type)=>type.test(v));
function $0c36e62e136cd5f2$var$asRGBA(color) {
    const type = $0c36e62e136cd5f2$var$getColorType(color);
    (0, $ee01c60b140b7aca$export$491112666e282270)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $5d13bfbdbf849b86$export$810b04175080204c)) // TODO Remove this cast - needed since Motion's stricter typing
    model = (0, $674c258fc0d9ff59$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $0c36e62e136cd5f2$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $0c36e62e136cd5f2$var$asRGBA(from);
    const toRGBA = $0c36e62e136cd5f2$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $2682c8e5db4ec62c$export$a6f92d4bae65c0f1)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $0c36e62e136cd5f2$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $0c36e62e136cd5f2$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $0c36e62e136cd5f2$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $f9223c1ee75bd9d2$export$3bb0b4ff1037b8dd)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $e5f666cc69ba56fe$export$4e46ac54fc82cf3b).transform(blended);
    };
};







const $d91e378e7e1db66d$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $d91e378e7e1db66d$export$fed62ccc3fb1a568(origin, target) {
    if ($d91e378e7e1db66d$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}



function $4324f555a8c3c7ce$var$mixNumber(a, b) {
    return (p)=>(0, $f9223c1ee75bd9d2$export$3bb0b4ff1037b8dd)(a, b, p);
}
function $4324f555a8c3c7ce$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $4324f555a8c3c7ce$var$mixNumber;
    else if (typeof a === "string") return (0, $f5a014041f41ad31$export$31f9caa2600b5723)(a) ? (0, $2682c8e5db4ec62c$export$a6f92d4bae65c0f1) : (0, $9c8ccc3d2a8382a3$export$35e9368ef982300f).test(a) ? (0, $0c36e62e136cd5f2$export$51e568cf5c039bac) : $4324f555a8c3c7ce$export$65516310a87d8205;
    else if (Array.isArray(a)) return $4324f555a8c3c7ce$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $9c8ccc3d2a8382a3$export$35e9368ef982300f).test(a) ? (0, $0c36e62e136cd5f2$export$51e568cf5c039bac) : $4324f555a8c3c7ce$export$ebc23b6840c51ba1;
    return 0, $2682c8e5db4ec62c$export$a6f92d4bae65c0f1;
}
function $4324f555a8c3c7ce$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$4324f555a8c3c7ce$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $4324f555a8c3c7ce$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $4324f555a8c3c7ce$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $4324f555a8c3c7ce$var$matchOrder(origin, target) {
    var _a;
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = (_a = origin.values[originIndex]) !== null && _a !== void 0 ? _a : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $4324f555a8c3c7ce$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $40298161d380ddb8$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $40298161d380ddb8$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $40298161d380ddb8$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $d91e378e7e1db66d$export$e5a55ae567dd4ac7).has(origin) && !targetStats.values.length || (0, $d91e378e7e1db66d$export$e5a55ae567dd4ac7).has(target) && !originStats.values.length) return (0, $d91e378e7e1db66d$export$fed62ccc3fb1a568)(origin, target);
        return (0, $318e0284607805bc$export$a4627e546088548d)($4324f555a8c3c7ce$export$3bbefa2f402845c4($4324f555a8c3c7ce$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $ee01c60b140b7aca$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (0, $2682c8e5db4ec62c$export$a6f92d4bae65c0f1)(origin, target);
    }
};



function $0cf644f09daf273f$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $f9223c1ee75bd9d2$export$3bb0b4ff1037b8dd)(from, to, p);
    const mixer = (0, $4324f555a8c3c7ce$export$36ec24672cd098e0)(from);
    return mixer(from, to);
}


function $d08b40ff4e668a4c$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $0cf644f09daf273f$export$2c9e8a9632a706b2);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $b971a0c42800d23e$export$8793edee2d425525) : ease;
            mixer = (0, $318e0284607805bc$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $d08b40ff4e668a4c$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $ee01c60b140b7aca$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && input[0] === input[1]) return ()=>output[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $d08b40ff4e668a4c$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $cb0a4d7c7c382e92$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $0c8f57795abc012c$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}



function $667621ce3d8e4ca4$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $1c32111ddabd7ae2$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $c97dfae3fbc87913$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $1c32111ddabd7ae2$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $3132f01cfd2c6d0a$export$216948827bbdc797)(ease) ? ease.map((0, $0388414a5f74d827$export$ef97fe084f156ca4)) : (0, $0388414a5f74d827$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $667621ce3d8e4ca4$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $496e670188b9fbda$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $d08b40ff4e668a4c$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $1c32111ddabd7ae2$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}











const $a00ffc566fbac964$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $4758d27de84673ea$export$2cef06c20297c17d).update(passTimestamp, true),
        stop: ()=>(0, $4758d27de84673ea$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $4758d27de84673ea$export$fff89137e9e818ce).isProcessing ? (0, $4758d27de84673ea$export$fff89137e9e818ce).timestamp : (0, $92548cb66fe736dd$export$2da9be4cfdb689b1).now()
    };
};




const $8df2bee92d9f3a73$var$generators = {
    decay: (0, $b8e71a46129480ee$export$ee3ff3a17106998),
    inertia: $b8e71a46129480ee$export$ee3ff3a17106998,
    tween: (0, $1c32111ddabd7ae2$export$d25ddfdf17c3ad3e),
    keyframes: (0, $1c32111ddabd7ae2$export$d25ddfdf17c3ad3e),
    spring: $0071f122a870be26$export$b36281d89752ae66
};
const $8df2bee92d9f3a73$var$percentToProgress = (percent)=>percent / 100;
/**
 * Animation that runs on the main thread. Designed to be WAAPI-spec in the subset of
 * features we expose publically. Mostly the compatibility is to ensure visual identity
 * between both WAAPI and main thread animations.
 */ class $8df2bee92d9f3a73$export$fd98d9cca67a58bc extends (0, $6c958fe978f62ea5$export$d1e4f34b9c2550c1) {
    constructor(options){
        super(options);
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * The time at which the animation was cancelled.
         */ this.cancelTime = null;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * The state of the animation to apply when the animation is resolved. This
         * allows calls to the public API to control the animation before it is resolved,
         * without us having to resolve it first.
         */ this.pendingPlayState = "running";
        /**
         * The time at which the animation was started.
         */ this.startTime = null;
        this.state = "idle";
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            this.resolver.cancel();
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            const { onStop: onStop } = this.options;
            onStop && onStop();
        };
        const { name: name, motionValue: motionValue, element: element, keyframes: keyframes } = this.options;
        const KeyframeResolver$1 = (element === null || element === void 0 ? void 0 : element.KeyframeResolver) || (0, $74b30abfb1c5ca65$export$74d34ca3182f1750);
        const onResolved = (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
        this.resolver = new KeyframeResolver$1(keyframes, onResolved, name, motionValue, element);
        this.resolver.scheduleResolve();
    }
    flatten() {
        super.flatten();
        // If we've already resolved the animation, re-initialise it
        if (this._resolved) Object.assign(this._resolved, this.initPlayback(this._resolved.keyframes));
    }
    initPlayback(keyframes$1) {
        const { type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = this.options;
        const generatorFactory = (0, $2bf3ea0c6e5a6324$export$6ab7812f1bac68be)(type) ? type : $8df2bee92d9f3a73$var$generators[type] || (0, $1c32111ddabd7ae2$export$d25ddfdf17c3ad3e);
        /**
         * If our generator doesn't support mixing numbers, we need to replace keyframes with
         * [0, 100] and then make a function that maps that to the actual keyframes.
         *
         * 100 is chosen instead of 1 as it works nicer with spring animations.
         */ let mapPercentToKeyframes;
        let mirroredGenerator;
        if (generatorFactory !== (0, $1c32111ddabd7ae2$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
            mapPercentToKeyframes = (0, $318e0284607805bc$export$a4627e546088548d)($8df2bee92d9f3a73$var$percentToProgress, (0, $0cf644f09daf273f$export$2c9e8a9632a706b2)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...this.options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") mirroredGenerator = generatorFactory({
            ...this.options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $22da538acfb87e5a$export$cbdd6b3d40ea54e2)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        const resolvedDuration = calculatedDuration + repeatDelay;
        const totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
        return {
            generator: generator,
            mirroredGenerator: mirroredGenerator,
            mapPercentToKeyframes: mapPercentToKeyframes,
            calculatedDuration: calculatedDuration,
            resolvedDuration: resolvedDuration,
            totalDuration: totalDuration
        };
    }
    onPostResolved() {
        const { autoplay: autoplay = true } = this.options;
        this.play();
        if (this.pendingPlayState === "paused" || !autoplay) this.pause();
        else this.state = this.pendingPlayState;
    }
    tick(timestamp, sample = false) {
        const { resolved: resolved } = this;
        // If the animations has failed to resolve, return the final keyframe.
        if (!resolved) {
            const { keyframes: keyframes } = this.options;
            return {
                done: true,
                value: keyframes[keyframes.length - 1]
            };
        }
        const { finalKeyframe: finalKeyframe, generator: generator, mirroredGenerator: mirroredGenerator, mapPercentToKeyframes: mapPercentToKeyframes, keyframes: keyframes, calculatedDuration: calculatedDuration, totalDuration: totalDuration, resolvedDuration: resolvedDuration } = resolved;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, onUpdate: onUpdate } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        // Update currentTime
        if (sample) this.currentTime = timestamp;
        else if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = Math.round(timestamp - this.startTime) * this.speed;
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.speed >= 0 ? 1 : -1);
        const isInDelayPhase = this.speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $0c8f57795abc012c$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mapPercentToKeyframes) state.value = mapPercentToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.speed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        if (isAnimationFinished && finalKeyframe !== undefined) state.value = (0, $bfa7d90c3370aa25$export$14de59408fad90b)(keyframes, this.options, finalKeyframe);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    get duration() {
        const { resolved: resolved } = this;
        return resolved ? (0, $a20bf34b6c7fb9be$export$f64c3bfbc58eec0f)(resolved.calculatedDuration) : 0;
    }
    get time() {
        return (0, $a20bf34b6c7fb9be$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $a20bf34b6c7fb9be$export$fc3e7e8557f8c8c7)(newTime);
        this.currentTime = newTime;
        if (this.holdTime !== null || this.speed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.speed;
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $a20bf34b6c7fb9be$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    play() {
        if (!this.resolver.isScheduled) this.resolver.resume();
        if (!this._resolved) {
            this.pendingPlayState = "running";
            return;
        }
        if (this.isStopped) return;
        const { driver: driver = (0, $a00ffc566fbac964$export$c1033964b5ad7fef), onPlay: onPlay, startTime: startTime } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        onPlay && onPlay();
        const now = this.driver.now();
        if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime) this.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        else if (this.state === "finished") this.startTime = now;
        if (this.state === "finished") this.updateFinishedPromise();
        this.cancelTime = this.startTime;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        var _a;
        if (!this._resolved) {
            this.pendingPlayState = "paused";
            return;
        }
        this.state = "paused";
        this.holdTime = (_a = this.currentTime) !== null && _a !== void 0 ? _a : 0;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.pendingPlayState = this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.teardown();
        this.state = "finished";
        const { onComplete: onComplete } = this.options;
        onComplete && onComplete();
    }
    cancel() {
        if (this.cancelTime !== null) this.tick(this.cancelTime);
        this.teardown();
        this.updateFinishedPromise();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        this.startTime = this.cancelTime = null;
        this.resolver.cancel();
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(time) {
        this.startTime = 0;
        return this.tick(time, true);
    }
}
// Legacy interface
function $8df2bee92d9f3a73$export$ee9b76de7353d815(options) {
    return new $8df2bee92d9f3a73$export$fd98d9cca67a58bc(options);
}


/**
 * A list of values that can be hardware-accelerated.
 */ const $c6f2806fee268e6c$export$a27eefbd8fb5e404 = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);





/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ const $577d7023231c33df$export$e3ad02c335474dee = {
    linearEasing: undefined
};


function $aff8e0f0c42b2180$export$1964673d5ec13c3a(callback, supportsFlag) {
    const memoized = (0, $22652eaee0e28bba$export$7c73462e0d25e514)(callback);
    return ()=>{
        var _a;
        return (_a = (0, $577d7023231c33df$export$e3ad02c335474dee)[supportsFlag]) !== null && _a !== void 0 ? _a : memoized();
    };
}


const $cd6d73754cf7acf8$export$866c1d07a1ac2ab = /*@__PURE__*/ (0, $aff8e0f0c42b2180$export$1964673d5ec13c3a)(()=>{
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");


function $c4fe73d2487a8475$export$fcdd8f3f2160beda(easing) {
    return Boolean(typeof easing === "function" && (0, $cd6d73754cf7acf8$export$866c1d07a1ac2ab)() || !easing || typeof easing === "string" && (easing in $c4fe73d2487a8475$export$2cf569f5e2221176 || (0, $cd6d73754cf7acf8$export$866c1d07a1ac2ab)()) || (0, $3a6a3225e430b117$export$ff43f99925d7366b)(easing) || Array.isArray(easing) && easing.every($c4fe73d2487a8475$export$fcdd8f3f2160beda));
}
const $c4fe73d2487a8475$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $c4fe73d2487a8475$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ $c4fe73d2487a8475$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ $c4fe73d2487a8475$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ $c4fe73d2487a8475$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ $c4fe73d2487a8475$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $c4fe73d2487a8475$export$916ea73bcd3a6030(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function" && (0, $cd6d73754cf7acf8$export$866c1d07a1ac2ab)()) return (0, $6895d092cec78af0$export$66d3851e2b1ec912)(easing, duration);
    else if ((0, $3a6a3225e430b117$export$ff43f99925d7366b)(easing)) return $c4fe73d2487a8475$export$2523b8f0bd8f44cb(easing);
    else if (Array.isArray(easing)) return easing.map((segmentEasing)=>$c4fe73d2487a8475$export$916ea73bcd3a6030(segmentEasing, duration) || $c4fe73d2487a8475$export$2cf569f5e2221176.easeOut);
    else return $c4fe73d2487a8475$export$2cf569f5e2221176[easing];
}


function $785c4f750ded0516$export$d896de52f97cb615(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease = "easeInOut", times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $c4fe73d2487a8475$export$916ea73bcd3a6030)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}



function $49599eefefc6e74e$export$5bd0fcbc73622e13(animation, timeline) {
    animation.timeline = timeline;
    animation.onfinish = null;
}





const $a359bcff08b7925e$export$51ea9b46fb7a8c5d = /*@__PURE__*/ (0, $22652eaee0e28bba$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));


/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $195a61e3ab46bbb6$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $195a61e3ab46bbb6$var$maxDuration = 20000;
/**
 * Check if an animation can run natively via WAAPI or requires pregenerated keyframes.
 * WAAPI doesn't support spring or function easings so we run these as JS animation before
 * handing off.
 */ function $195a61e3ab46bbb6$var$requiresPregeneratedKeyframes(options) {
    return (0, $2bf3ea0c6e5a6324$export$6ab7812f1bac68be)(options.type) || options.type === "spring" || !(0, $c4fe73d2487a8475$export$fcdd8f3f2160beda)(options.ease);
}
function $195a61e3ab46bbb6$var$pregenerateKeyframes(keyframes, options) {
    /**
     * Create a main-thread animation to pregenerate keyframes.
     * We sample this at regular intervals to generate keyframes that we then
     * linearly interpolate between.
     */ const sampleAnimation = new (0, $8df2bee92d9f3a73$export$fd98d9cca67a58bc)({
        ...options,
        keyframes: keyframes,
        repeat: 0,
        delay: 0,
        isGenerator: true
    });
    let state = {
        done: false,
        value: keyframes[0]
    };
    const pregeneratedKeyframes = [];
    /**
     * Bail after 20 seconds of pre-generated keyframes as it's likely
     * we're heading for an infinite loop.
     */ let t = 0;
    while(!state.done && t < $195a61e3ab46bbb6$var$maxDuration){
        state = sampleAnimation.sample(t);
        pregeneratedKeyframes.push(state.value);
        t += $195a61e3ab46bbb6$var$sampleDelta;
    }
    return {
        times: undefined,
        keyframes: pregeneratedKeyframes,
        duration: t - $195a61e3ab46bbb6$var$sampleDelta,
        ease: "linear"
    };
}
const $195a61e3ab46bbb6$var$unsupportedEasingFunctions = {
    anticipate: $3f0ae1983c3701f3$export$6b0af63b873d419e,
    backInOut: $15e1d000a158db8b$export$ddc5fd596f6c71b2,
    circInOut: $f21058ca353e4e4a$export$30d3455eee55bed5
};
function $195a61e3ab46bbb6$var$isUnsupportedEase(key) {
    return key in $195a61e3ab46bbb6$var$unsupportedEasingFunctions;
}
class $195a61e3ab46bbb6$export$2a45abb4e6513325 extends (0, $6c958fe978f62ea5$export$d1e4f34b9c2550c1) {
    constructor(options){
        super(options);
        const { name: name, motionValue: motionValue, element: element, keyframes: keyframes } = this.options;
        this.resolver = new (0, $7a8f8b7884b040ae$export$4983792d11b61017)(keyframes, (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe), name, motionValue, element);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes, finalKeyframe) {
        var _a;
        let { duration: duration = 300, times: times, ease: ease, type: type, motionValue: motionValue, name: name, startTime: startTime } = this.options;
        /**
         * If element has since been unmounted, return false to indicate
         * the animation failed to initialised.
         */ if (!((_a = motionValue.owner) === null || _a === void 0 ? void 0 : _a.current)) return false;
        /**
         * If the user has provided an easing function name that isn't supported
         * by WAAPI (like "anticipate"), we need to provide the corressponding
         * function. This will later get converted to a linear() easing function.
         */ if (typeof ease === "string" && (0, $cd6d73754cf7acf8$export$866c1d07a1ac2ab)() && $195a61e3ab46bbb6$var$isUnsupportedEase(ease)) ease = $195a61e3ab46bbb6$var$unsupportedEasingFunctions[ease];
        /**
         * If this animation needs pre-generated keyframes then generate.
         */ if ($195a61e3ab46bbb6$var$requiresPregeneratedKeyframes(this.options)) {
            const { onComplete: onComplete, onUpdate: onUpdate, motionValue: motionValue, element: element, ...options } = this.options;
            const pregeneratedAnimation = $195a61e3ab46bbb6$var$pregenerateKeyframes(keyframes, options);
            keyframes = pregeneratedAnimation.keyframes;
            // If this is a very short animation, ensure we have
            // at least two keyframes to animate between as older browsers
            // can't animate between a single keyframe.
            if (keyframes.length === 1) keyframes[1] = keyframes[0];
            duration = pregeneratedAnimation.duration;
            times = pregeneratedAnimation.times;
            ease = pregeneratedAnimation.ease;
            type = "keyframes";
        }
        const animation = (0, $785c4f750ded0516$export$d896de52f97cb615)(motionValue.owner.current, name, keyframes, {
            ...this.options,
            duration: duration,
            times: times,
            ease: ease
        });
        // Override the browser calculated startTime with one synchronised to other JS
        // and WAAPI animations starting this event loop.
        animation.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        if (this.pendingTimeline) {
            (0, $49599eefefc6e74e$export$5bd0fcbc73622e13)(animation, this.pendingTimeline);
            this.pendingTimeline = undefined;
        } else /**
             * Prefer the `onfinish` prop as it's more widely supported than
             * the `finished` promise.
             *
             * Here, we synchronously set the provided MotionValue to the end
             * keyframe. If we didn't, when the WAAPI animation is finished it would
             * be removed from the element which would then revert to its old styles.
             */ animation.onfinish = ()=>{
            const { onComplete: onComplete } = this.options;
            motionValue.set((0, $bfa7d90c3370aa25$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
            onComplete && onComplete();
            this.cancel();
            this.resolveFinishedPromise();
        };
        return {
            animation: animation,
            duration: duration,
            times: times,
            type: type,
            ease: ease,
            keyframes: keyframes
        };
    }
    get duration() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { duration: duration } = resolved;
        return (0, $a20bf34b6c7fb9be$export$f64c3bfbc58eec0f)(duration);
    }
    get time() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { animation: animation } = resolved;
        return (0, $a20bf34b6c7fb9be$export$f64c3bfbc58eec0f)(animation.currentTime || 0);
    }
    set time(newTime) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.currentTime = (0, $a20bf34b6c7fb9be$export$fc3e7e8557f8c8c7)(newTime);
    }
    get speed() {
        const { resolved: resolved } = this;
        if (!resolved) return 1;
        const { animation: animation } = resolved;
        return animation.playbackRate;
    }
    set speed(newSpeed) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.playbackRate = newSpeed;
    }
    get state() {
        const { resolved: resolved } = this;
        if (!resolved) return "idle";
        const { animation: animation } = resolved;
        return animation.playState;
    }
    get startTime() {
        const { resolved: resolved } = this;
        if (!resolved) return null;
        const { animation: animation } = resolved;
        // Coerce to number as TypeScript incorrectly types this
        // as CSSNumberish
        return animation.startTime;
    }
    /**
     * Replace the default DocumentTimeline with another AnimationTimeline.
     * Currently used for scroll animations.
     */ attachTimeline(timeline) {
        if (!this._resolved) this.pendingTimeline = timeline;
        else {
            const { resolved: resolved } = this;
            if (!resolved) return 0, $b971a0c42800d23e$export$8793edee2d425525;
            const { animation: animation } = resolved;
            (0, $49599eefefc6e74e$export$5bd0fcbc73622e13)(animation, timeline);
        }
        return 0, $b971a0c42800d23e$export$8793edee2d425525;
    }
    play() {
        if (this.isStopped) return;
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        if (animation.playState === "finished") this.updateFinishedPromise();
        animation.play();
    }
    pause() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.pause();
    }
    stop() {
        this.resolver.cancel();
        this.isStopped = true;
        if (this.state === "idle") return;
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation, keyframes: keyframes, duration: duration, type: type, ease: ease, times: times } = resolved;
        if (animation.playState === "idle" || animation.playState === "finished") return;
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */ if (this.time) {
            const { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, element: element, ...options } = this.options;
            const sampleAnimation = new (0, $8df2bee92d9f3a73$export$fd98d9cca67a58bc)({
                ...options,
                keyframes: keyframes,
                duration: duration,
                type: type,
                ease: ease,
                times: times,
                isGenerator: true
            });
            const sampleTime = (0, $a20bf34b6c7fb9be$export$fc3e7e8557f8c8c7)(this.time);
            motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $195a61e3ab46bbb6$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $195a61e3ab46bbb6$var$sampleDelta);
        }
        const { onStop: onStop } = this.options;
        onStop && onStop();
        this.cancel();
    }
    complete() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.finish();
    }
    cancel() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.cancel();
    }
    static supports(options) {
        const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type } = options;
        return (0, $a359bcff08b7925e$export$51ea9b46fb7a8c5d)() && name && (0, $c6f2806fee268e6c$export$a27eefbd8fb5e404).has(name) && motionValue && motionValue.owner && motionValue.owner.current instanceof HTMLElement && /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */ !motionValue.owner.getProps().onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
    }
}




/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $c0ba56ff5ef7908b$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}


const $d817219526c6c9f3$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, $e4954370239e76c9$export$7c1391340308742e)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $a20bf34b6c7fb9be$export$fc3e7e8557f8c8c7)(delay);
        let options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unqiue transition settings for this value.
     */ if (!(0, $c0ba56ff5ef7908b$export$ca8e47dc8ed5a9d7)(valueTransition)) options = {
            ...options,
            ...(0, $e57734ee27140fe9$export$262124b154b9f1c0)(name, options)
        };
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ if (options.duration) options.duration = (0, $a20bf34b6c7fb9be$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $a20bf34b6c7fb9be$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            options.duration = 0;
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $190bc1bbe58c023a$export$888a3d84909f9e3d).current || (0, $c0fc7f8d5f614817$export$dd826089e3c5e502).skipAnimations) {
            shouldSkip = true;
            options.duration = 0;
            options.delay = 0;
        }
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $bfa7d90c3370aa25$export$14de59408fad90b)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $4758d27de84673ea$export$2cef06c20297c17d).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                // We still want to return some animation controls here rather
                // than returning undefined
                return new (0, $740d8c3a222837de$export$c1e41718f71efe41)([]);
            }
        }
        /**
     * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */ if (!isHandoff && (0, $195a61e3ab46bbb6$export$2a45abb4e6513325).supports(options)) return new (0, $195a61e3ab46bbb6$export$2a45abb4e6513325)(options);
        else return new (0, $8df2bee92d9f3a73$export$fd98d9cca67a58bc)(options);
    };


const $670dec034de39b06$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


const $71dc8b03d38e4803$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $71dc8b03d38e4803$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $670dec034de39b06$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};



class $b79aca5c4afda727$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $1a4ec488c9eadfe6$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $1a4ec488c9eadfe6$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}






/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $ea7fd34eccc8f1da$var$MAX_VELOCITY_DELTA = 30;
const $ea7fd34eccc8f1da$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $ea7fd34eccc8f1da$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $ea7fd34eccc8f1da$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "11.15.0";
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            const currentTime = (0, $92548cb66fe736dd$export$2da9be4cfdb689b1).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev && this.events.change) this.events.change.notify(this.current);
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $92548cb66fe736dd$export$2da9be4cfdb689b1).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $ea7fd34eccc8f1da$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $b79aca5c4afda727$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $4758d27de84673ea$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($ea7fd34eccc8f1da$export$67fcd818a264039d.current) $ea7fd34eccc8f1da$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $92548cb66fe736dd$export$2da9be4cfdb689b1).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $ea7fd34eccc8f1da$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $ea7fd34eccc8f1da$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $9b2f55ea2d96c166$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $ea7fd34eccc8f1da$export$ce8bdc721e76545f(init, options) {
    return new $ea7fd34eccc8f1da$export$8cea36d14ee64562(init, options);
}


function $babf352c68c7d85d$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement === null || visualElement === void 0 || visualElement.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $babf352c68c7d85d$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $babf352c68c7d85d$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $babf352c68c7d85d$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}


function $05bff1afc3cfb905$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $babf352c68c7d85d$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}


/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $496de0147ce8b98a$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $ea7fd34eccc8f1da$export$ce8bdc721e76545f)(value));
}
function $496de0147ce8b98a$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $05bff1afc3cfb905$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $71dc8b03d38e4803$export$5485128c47bd48bb)(target[key]);
        $496de0147ce8b98a$var$setMotionValue(visualElement, key, value);
    }
}



/**
 * Convert camelCase to dash-case properties.
 */ const $248f4e0a8f5ae494$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();


const $c453793bf19cce41$export$ed7b8fa9dbf0105d = "framerAppearId";
const $c453793bf19cce41$export$8592e1c077c890a6 = "data-" + (0, $248f4e0a8f5ae494$export$9fd24a634729c672)($c453793bf19cce41$export$ed7b8fa9dbf0105d);


function $9125c5d1c21b67a0$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $c453793bf19cce41$export$8592e1c077c890a6];
}



function $1aaf567888547bac$export$98397f3adbf6259f(value) {
    return Boolean((0, $6d518b48081ad760$export$605d60a2578142d3)(value) && value.add);
}


function $a64116eddac446f4$export$3ac5aed310be0bee(visualElement, key) {
    const willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $1aaf567888547bac$export$98397f3adbf6259f)(willChange)) return willChange.add(key);
}



/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $e50f3bb987e22e02$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $e50f3bb987e22e02$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    var _a;
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = targetAndTransition;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, (_a = visualElement.latestValues[key]) !== null && _a !== void 0 ? _a : null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $e50f3bb987e22e02$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            ...(0, $e4954370239e76c9$export$7c1391340308742e)(transition || {}, key)
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, $9125c5d1c21b67a0$export$5f8d21e84d1d84fc)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, $4758d27de84673ea$export$2cef06c20297c17d));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, $a64116eddac446f4$export$3ac5aed310be0bee)(visualElement, key);
        value.start((0, $d817219526c6c9f3$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $703b4bcf0b7f8381$export$7b42a0094fb00b6e).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $4758d27de84673ea$export$2cef06c20297c17d).update(()=>{
            transitionEnd && (0, $496de0147ce8b98a$export$1f61c53461aff4a5)(visualElement, transitionEnd);
        });
    });
    return animations;
}


function $672ff84cea120593$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}



const $fde14dcf9dcc6831$export$91ddd985b97788d1 = {};
function $fde14dcf9dcc6831$export$de9e7791c71225fd(correctors) {
    Object.assign($fde14dcf9dcc6831$export$91ddd985b97788d1, correctors);
}



function $3217e823b9ba1ef5$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $703b4bcf0b7f8381$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $fde14dcf9dcc6831$export$91ddd985b97788d1)[key] || key === "opacity");
}



function $5a6de14cff820589$export$16da615486abaa45(props, prevProps, visualElement) {
    var _a;
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $6d518b48081ad760$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $6d518b48081ad760$export$605d60a2578142d3)(prevProps.style[key]) || (0, $3217e823b9ba1ef5$export$6d27ce8e3de1c3cf)(key, props) || ((_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.liveStyle) !== undefined) newValues[key] = style[key];
    return newValues;
}



function $87b23dbe36a80db0$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $5a6de14cff820589$export$16da615486abaa45)(props, prevProps, visualElement);
    for(const key in props)if ((0, $6d518b48081ad760$export$605d60a2578142d3)(props[key]) || (0, $6d518b48081ad760$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $703b4bcf0b7f8381$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}


const $1259b541dee92012$export$4e09c449d6c407f7 = typeof window !== "undefined";


// Does this device prefer reduced motion? Returns `null` server-side.
const $c8de5dc83b44af85$export$ff7706047246b98b = {
    current: null
};
const $c8de5dc83b44af85$export$6476d16e2fd2d0db = {
    current: false
};


function $331f333e9a872e36$export$ca9f41fb23dded3d() {
    (0, $c8de5dc83b44af85$export$6476d16e2fd2d0db).current = true;
    if (!(0, $1259b541dee92012$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $c8de5dc83b44af85$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $c8de5dc83b44af85$export$ff7706047246b98b).current = false;
}







function $584ef36e4b63896e$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}


/**
 * Decides if the supplied variable is variant label
 */ function $c2a052096d148c34$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


const $084c1566c9bed1e7$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $084c1566c9bed1e7$export$1405a65085f40b9 = [
    "initial",
    ...$084c1566c9bed1e7$export$16e45afcc206d3a8
];


function $a2eb636aacf5f2f4$export$4b3c3bd8d910d78d(props) {
    return (0, $584ef36e4b63896e$export$aa71198ceeaf53ce)(props.animate) || (0, $084c1566c9bed1e7$export$1405a65085f40b9).some((name)=>(0, $c2a052096d148c34$export$720b90e312cea233)(props[name]));
}
function $a2eb636aacf5f2f4$export$ce46fa4165cdec40(props) {
    return Boolean($a2eb636aacf5f2f4$export$4b3c3bd8d910d78d(props) || props.variants);
}





function $757671526ed00457$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $6d518b48081ad760$export$605d60a2578142d3)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $6d518b48081ad760$export$605d60a2578142d3)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $ea7fd34eccc8f1da$export$ce8bdc721e76545f)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $ea7fd34eccc8f1da$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}




const $fb0e8a64a1af7da5$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $fb0e8a64a1af7da5$export$65570e08d843624d = {};
for(const key in $fb0e8a64a1af7da5$var$featureProps)$fb0e8a64a1af7da5$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$fb0e8a64a1af7da5$var$featureProps[key].some((name)=>!!props[name])
};










/**
 * A list of all ValueTypes
 */ const $ea57d1d43244a62c$var$valueTypes = [
    ...(0, $a6dbbf483881cd85$export$d176691c1998a1f5),
    (0, $9c8ccc3d2a8382a3$export$35e9368ef982300f),
    (0, $40298161d380ddb8$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $ea57d1d43244a62c$export$950e7e59ea1ffed7 = (v)=>$ea57d1d43244a62c$var$valueTypes.find((0, $7a46dcf899ee8d83$export$6eae4d0a6a7ca7cd)(v));




const $c5fb7364a5b05d7b$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $c5fb7364a5b05d7b$export$3d227df54007d73a = ()=>({
        x: $c5fb7364a5b05d7b$export$ff25708b37f72782(),
        y: $c5fb7364a5b05d7b$export$ff25708b37f72782()
    });
const $c5fb7364a5b05d7b$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $c5fb7364a5b05d7b$export$6459fc9e86be362e = ()=>({
        x: $c5fb7364a5b05d7b$export$6db76765312617ac(),
        y: $c5fb7364a5b05d7b$export$6db76765312617ac()
    });




const $b5dbcf7a33f056d8$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $b5dbcf7a33f056d8$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $74b30abfb1c5ca65$export$74d34ca3182f1750);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = ()=>{
            const now = (0, $92548cb66fe736dd$export$2da9be4cfdb689b1).now();
            if (this.renderScheduledAt < now) {
                this.renderScheduledAt = now;
                (0, $4758d27de84673ea$export$2cef06c20297c17d).render(this.render, false, true);
            }
        };
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $a2eb636aacf5f2f4$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $a2eb636aacf5f2f4$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $6d518b48081ad760$export$605d60a2578142d3)(value)) value.set(latestValues[key], false);
        }
    }
    mount(instance) {
        this.current = instance;
        (0, $6c06a4cd41166f69$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $c8de5dc83b44af85$export$6476d16e2fd2d0db).current) (0, $331f333e9a872e36$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $c8de5dc83b44af85$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $6c06a4cd41166f69$export$bc2a978a17abfdde).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $4758d27de84673ea$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $4758d27de84673ea$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        const valueIsTransform = (0, $703b4bcf0b7f8381$export$7b42a0094fb00b6e).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $4758d27de84673ea$export$2cef06c20297c17d).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        let removeSyncCheck;
        if (window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
            if (removeSyncCheck) removeSyncCheck();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in 0, $fb0e8a64a1af7da5$export$65570e08d843624d){
            const featureDefinition = (0, $fb0e8a64a1af7da5$export$65570e08d843624d)[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $c5fb7364a5b05d7b$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $b5dbcf7a33f056d8$var$propEventHandlers.length; i++){
            const key = $b5dbcf7a33f056d8$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $757671526ed00457$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $ea7fd34eccc8f1da$export$ce8bdc721e76545f)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        var _a;
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $dc2715baad060b2c$export$65583ed5a868f2d9)(value) || (0, $057e65c4a62bce07$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $ea57d1d43244a62c$export$950e7e59ea1ffed7)(value) && (0, $40298161d380ddb8$export$83a0e34f1302825b).test(target)) value = (0, $4adf6409e3ad163d$export$cea0cedcb94873b5)(key, target);
            this.setBaseTarget(key, (0, $6d518b48081ad760$export$605d60a2578142d3)(value) ? value.get() : value);
        }
        return (0, $6d518b48081ad760$export$605d60a2578142d3)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $babf352c68c7d85d$export$d68f140c4d9b48bc)(this.props, initial, (_a = this.presenceContext) === null || _a === void 0 ? void 0 : _a.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $6d518b48081ad760$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $b79aca5c4afda727$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}




class $e949121757b0cb0e$export$e49735c2a366bdc7 extends (0, $b5dbcf7a33f056d8$export$fa8b653c0f3714e5) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $7a8f8b7884b040ae$export$4983792d11b61017);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $6d518b48081ad760$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
}



/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $cab86f93d0b72fc5$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};



const $79792256e2cf290a$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $79792256e2cf290a$var$numTransforms = (0, $703b4bcf0b7f8381$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $79792256e2cf290a$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $79792256e2cf290a$var$numTransforms; i++){
        const key = (0, $703b4bcf0b7f8381$export$280dc01950909d86)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else valueIsDefault = parseFloat(value) === 0;
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, $cab86f93d0b72fc5$export$453ef540a9a1bd6b)(value, (0, $1981f705a943c01a$export$eec14432cd1cb67b)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = $79792256e2cf290a$var$translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}






function $925a3170675a121e$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style, vars: vars, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, $703b4bcf0b7f8381$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $f5a014041f41ad31$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, $cab86f93d0b72fc5$export$453ef540a9a1bd6b)(value, (0, $1981f705a943c01a$export$eec14432cd1cb67b)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $79792256e2cf290a$export$bdc96e0d5c8f914)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}



function $848735443b666242$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $848735443b666242$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $848735443b666242$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $848735443b666242$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}



const $8e2b87ece4563348$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $8e2b87ece4563348$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $8e2b87ece4563348$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $8e2b87ece4563348$var$dashKeys : $8e2b87ece4563348$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $55eef29d1f3b7d7e$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $8eb497f801f27e48$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate) {
    (0, $925a3170675a121e$export$bb517f8b40f8e99d)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $848735443b666242$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $8e2b87ece4563348$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}



/**
 * A set of attribute names that are always read/written as camel case.
 */ const $c49f6af725dd3e79$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);




function $b5e396fd5b900e78$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}



function $8d70b9a81bba0a69$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $b5e396fd5b900e78$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $c49f6af725dd3e79$export$28931db5d57958e5).has(key) ? (0, $248f4e0a8f5ae494$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}




const $304631853a0216d4$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";


class $657cd02759696c81$export$86bcdffbaf733d84 extends (0, $e949121757b0cb0e$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, $c5fb7364a5b05d7b$export$6459fc9e86be362e);
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $703b4bcf0b7f8381$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $14b8677d55ad0a7c$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $c49f6af725dd3e79$export$28931db5d57958e5).has(key) ? (0, $248f4e0a8f5ae494$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $87b23dbe36a80db0$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        (0, $8eb497f801f27e48$export$5475d24f125d7053)(renderState, latestValues, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $8d70b9a81bba0a69$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $304631853a0216d4$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}








/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $614dc36be07e9118$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $614dc36be07e9118$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $614dc36be07e9118$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $e59f2e2815ed8cae$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $e59f2e2815ed8cae$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$e59f2e2815ed8cae$var$isIdentityScale(scale) || !$e59f2e2815ed8cae$var$isIdentityScale(scaleX) || !$e59f2e2815ed8cae$var$isIdentityScale(scaleY);
}
function $e59f2e2815ed8cae$export$a545127cf1fbb600(values) {
    return $e59f2e2815ed8cae$export$bdf30dca883ea463(values) || $e59f2e2815ed8cae$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $e59f2e2815ed8cae$export$bf80f5f8f4dc327f(values) {
    return $e59f2e2815ed8cae$var$is2DTranslate(values.x) || $e59f2e2815ed8cae$var$is2DTranslate(values.y);
}
function $e59f2e2815ed8cae$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $c2ee59463f825be8$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $c2ee59463f825be8$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $c2ee59463f825be8$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $c2ee59463f825be8$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $c2ee59463f825be8$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $c2ee59463f825be8$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $c2ee59463f825be8$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $c2ee59463f825be8$export$d80074982803af5c(box, { x: x, y: y }) {
    $c2ee59463f825be8$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $c2ee59463f825be8$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
const $c2ee59463f825be8$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
const $c2ee59463f825be8$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $c2ee59463f825be8$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $c2ee59463f825be8$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $c2ee59463f825be8$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $e59f2e2815ed8cae$export$a545127cf1fbb600)(node.latestValues)) $c2ee59463f825be8$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $c2ee59463f825be8$var$TREE_SCALE_SNAP_MAX && treeScale.x > $c2ee59463f825be8$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $c2ee59463f825be8$var$TREE_SCALE_SNAP_MAX && treeScale.y > $c2ee59463f825be8$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $c2ee59463f825be8$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $c2ee59463f825be8$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $f9223c1ee75bd9d2$export$3bb0b4ff1037b8dd)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $c2ee59463f825be8$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $c2ee59463f825be8$export$58b16271041fbfb(box, transform) {
    $c2ee59463f825be8$export$625f1dd140a2f5e7(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
    $c2ee59463f825be8$export$625f1dd140a2f5e7(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}


function $4910f3df9fbc224f$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $614dc36be07e9118$export$d3955c6a8f65a36b)((0, $614dc36be07e9118$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $4910f3df9fbc224f$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $4910f3df9fbc224f$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $c2ee59463f825be8$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $c2ee59463f825be8$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}



function $445308de6c586a8e$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $445308de6c586a8e$export$23fea75b03ac16b3 extends (0, $e949121757b0cb0e$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "html";
        this.renderInstance = (0, $b5e396fd5b900e78$export$1a32bf6229c258c0);
    }
    readValueFromInstance(instance, key) {
        if ((0, $703b4bcf0b7f8381$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $14b8677d55ad0a7c$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $445308de6c586a8e$export$3735103072e4a80(instance);
            const value = ((0, $f5a014041f41ad31$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $4910f3df9fbc224f$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $925a3170675a121e$export$bb517f8b40f8e99d)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $5a6de14cff820589$export$16da615486abaa45)(props, prevProps, visualElement);
    }
}





function $7c8dda4fc1dcf443$var$isObjectKey(key, object) {
    return key in object;
}
class $7c8dda4fc1dcf443$export$fe67a5eca4e986d6 extends (0, $b5dbcf7a33f056d8$export$fa8b653c0f3714e5) {
    constructor(){
        super(...arguments);
        this.type = "object";
    }
    readValueFromInstance(instance, key) {
        if ($7c8dda4fc1dcf443$var$isObjectKey(key, instance)) {
            const value = instance[key];
            if (typeof value === "string" || typeof value === "number") return value;
        }
        return undefined;
    }
    getBaseTargetFromProps() {
        return undefined;
    }
    removeValueFromRenderState(key, renderState) {
        delete renderState.output[key];
    }
    measureInstanceViewportBox() {
        return (0, $c5fb7364a5b05d7b$export$6459fc9e86be362e)();
    }
    build(renderState, latestValues) {
        Object.assign(renderState.output, latestValues);
    }
    renderInstance(instance, { output: output }) {
        Object.assign(instance, output);
    }
    sortInstanceNodePosition() {
        return 0;
    }
}


function $5efef9895b77028e$export$602bd1946a6d1d47(element) {
    const options = {
        presenceContext: null,
        props: {},
        visualState: {
            renderState: {
                transform: {},
                transformOrigin: {},
                style: {},
                vars: {},
                attrs: {}
            },
            latestValues: {}
        }
    };
    const node = (0, $672ff84cea120593$export$17eda790a720ec57)(element) ? new (0, $657cd02759696c81$export$86bcdffbaf733d84)(options) : new (0, $445308de6c586a8e$export$23fea75b03ac16b3)(options);
    node.mount(element);
    (0, $6c06a4cd41166f69$export$bc2a978a17abfdde).set(element, node);
}
function $5efef9895b77028e$export$69c3b8be1812d4ee(subject) {
    const options = {
        presenceContext: null,
        props: {},
        visualState: {
            renderState: {
                output: {}
            },
            latestValues: {}
        }
    };
    const node = new (0, $7c8dda4fc1dcf443$export$fe67a5eca4e986d6)(options);
    node.mount(subject);
    (0, $6c06a4cd41166f69$export$bc2a978a17abfdde).set(subject, node);
}







function $539265a50a7bc732$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $6d518b48081ad760$export$605d60a2578142d3)(value) ? value : (0, $ea7fd34eccc8f1da$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $d817219526c6c9f3$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}


function $8f992da3ce27fb17$var$isSingleValue(subject, keyframes) {
    return (0, $6d518b48081ad760$export$605d60a2578142d3)(subject) || typeof subject === "number" || typeof subject === "string" && !(0, $82a8db1982ddf415$export$d276bfce3b1077ca)(keyframes);
}
/**
 * Implementation
 */ function $8f992da3ce27fb17$export$7f91f5969506fd92(subject, keyframes, options, scope) {
    const animations = [];
    if ($8f992da3ce27fb17$var$isSingleValue(subject, keyframes)) animations.push((0, $539265a50a7bc732$export$335a17c977067b99)(subject, (0, $82a8db1982ddf415$export$d276bfce3b1077ca)(keyframes) ? keyframes.default || keyframes : keyframes, options ? options.default || options : options));
    else {
        const subjects = (0, $38d9e3b87f69fbe7$export$92b2aefc56600400)(subject, keyframes, scope);
        const numSubjects = subjects.length;
        (0, $ee01c60b140b7aca$export$f5708dca728d7177)(Boolean(numSubjects), "No valid elements provided.");
        for(let i = 0; i < numSubjects; i++){
            const thisSubject = subjects[i];
            const createVisualElement = thisSubject instanceof Element ? (0, $5efef9895b77028e$export$602bd1946a6d1d47) : (0, $5efef9895b77028e$export$69c3b8be1812d4ee);
            if (!(0, $6c06a4cd41166f69$export$bc2a978a17abfdde).has(thisSubject)) createVisualElement(thisSubject);
            const visualElement = (0, $6c06a4cd41166f69$export$bc2a978a17abfdde).get(thisSubject);
            const transition = {
                ...options
            };
            /**
             * Resolve stagger function if provided.
             */ if ("delay" in transition && typeof transition.delay === "function") transition.delay = transition.delay(i, numSubjects);
            animations.push(...(0, $e50f3bb987e22e02$export$68cacfeee78d98d2)(visualElement, {
                ...keyframes,
                transition: transition
            }, {}));
        }
    }
    return animations;
}


function $f6ea4aca8e01fd15$export$82a013c5b12ef57f(sequence, options, scope) {
    const animations = [];
    const animationDefinitions = (0, $3d9025610d4b57b5$export$1f0f44b51a4b2f73)(sequence, options, scope, {
        spring: $0071f122a870be26$export$b36281d89752ae66
    });
    animationDefinitions.forEach(({ keyframes: keyframes, transition: transition }, subject)=>{
        animations.push(...(0, $8f992da3ce27fb17$export$7f91f5969506fd92)(subject, keyframes, transition));
    });
    return animations;
}



function $82b33e9ba0608c21$var$isSequence(value) {
    return Array.isArray(value) && Array.isArray(value[0]);
}
/**
 * Creates an animation function that is optionally scoped
 * to a specific element.
 */ function $82b33e9ba0608c21$export$c17e592002be9b90(scope) {
    /**
     * Implementation
     */ function scopedAnimate(subjectOrSequence, optionsOrKeyframes, options) {
        let animations = [];
        if ($82b33e9ba0608c21$var$isSequence(subjectOrSequence)) animations = (0, $f6ea4aca8e01fd15$export$82a013c5b12ef57f)(subjectOrSequence, optionsOrKeyframes, scope);
        else animations = (0, $8f992da3ce27fb17$export$7f91f5969506fd92)(subjectOrSequence, optionsOrKeyframes, options, scope);
        const animation = new (0, $740d8c3a222837de$export$c1e41718f71efe41)(animations);
        if (scope) scope.animations.push(animation);
        return animation;
    }
    return scopedAnimate;
}
const $82b33e9ba0608c21$export$e3607ec2d7a891c4 = $82b33e9ba0608c21$export$c17e592002be9b90();


function $ea6a64798899c842$export$35c8f6884e82cf8d(from, total) {
    if (from === "first") return 0;
    else {
        const lastIndex = total - 1;
        return from === "last" ? lastIndex : lastIndex / 2;
    }
}
function $ea6a64798899c842$export$ef0b4d89074db4d0(duration = 0.1, { startDelay: startDelay = 0, from: from = 0, ease: ease } = {}) {
    return (i, total)=>{
        const fromIndex = typeof from === "number" ? from : $ea6a64798899c842$export$35c8f6884e82cf8d(from, total);
        const distance = Math.abs(fromIndex - i);
        let delay = duration * distance;
        if (ease) {
            const maxDelay = total * duration;
            const easingFunction = (0, $0388414a5f74d827$export$ef97fe084f156ca4)(ease);
            delay = easingFunction(delay / maxDelay) * maxDelay;
        }
        return startDelay + delay;
    };
}


let $0f592d681121713f$var$isMobile = window.innerWidth < 768;
const $0f592d681121713f$var$createAnimation = ()=>{
    const spacing = $0f592d681121713f$var$isMobile ? 48 : 64;
    return (0, $82b33e9ba0608c21$export$e3607ec2d7a891c4)([
        [
            ".step-tile",
            {
                opacity: [
                    0,
                    1
                ]
            },
            {
                delay: (0, $ea6a64798899c842$export$ef0b4d89074db4d0)(0.1),
                duration: 0.1
            }
        ],
        [
            ".step:nth-last-child(-n+4)",
            {
                y: [
                    0,
                    spacing
                ]
            }
        ],
        [
            ".step:nth-last-child(-n+3)",
            {
                y: [
                    spacing,
                    spacing * 2
                ]
            }
        ],
        [
            ".step:nth-last-child(-n+2)",
            {
                y: [
                    spacing * 2,
                    spacing * 3
                ]
            }
        ],
        [
            ".step:nth-last-child(-n+1)",
            {
                y: [
                    spacing * 3,
                    spacing * 4
                ]
            }
        ],
        [
            ".step-label",
            // flicker effect
            {
                opacity: [
                    0,
                    1,
                    1,
                    0,
                    1
                ]
            },
            {
                duration: 0.1,
                delay: (0, $ea6a64798899c842$export$ef0b4d89074db4d0)(0.2),
                ease: "linear"
            }
        ],
        [
            ".step-dots",
            // mask in from right
            {
                clipPath: [
                    "inset(0 100% 0 0)",
                    "inset(0 0 0 0)"
                ]
            },
            {
                delay: (0, $ea6a64798899c842$export$ef0b4d89074db4d0)(0.1)
            }
        ],
        [
            ".steps-repeat",
            // mask from bottom to top
            {
                clipPath: [
                    "inset(100% 0 0 0)",
                    "inset(0 0 0 0)"
                ]
            }
        ]
    ]);
};
let $0f592d681121713f$var$animation = $0f592d681121713f$var$createAnimation();
window.addEventListener("resize", ()=>{
    const prevIsMobile = $0f592d681121713f$var$isMobile;
    $0f592d681121713f$var$isMobile = window.innerWidth < 768;
    console.log("resize", window.innerWidth, $0f592d681121713f$var$isMobile, prevIsMobile);
    if (prevIsMobile !== $0f592d681121713f$var$isMobile) {
        console.log("isMobile changed", $0f592d681121713f$var$isMobile);
        $0f592d681121713f$var$animation.cancel();
        $0f592d681121713f$var$animation = $0f592d681121713f$var$createAnimation();
    }
});


//# sourceMappingURL=index.24c33386.js.map
